<template>
  <div class="container basecenter">
    <div>
      <filter-tab @filterParam="getParam" :webId="2"></filter-tab>
    </div>

    <el-row class="common-box" style="margin-top: 20px;">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">筛选结果</h2>
        <!-- :disabled="auths.indexOf(2) < 0" -->
        <!-- <el-button type="primary" size="mini" round @click="logout"
                   :disabled="idList.length === 0 || auths.indexOf(2) < 0">注销
        </el-button> -->
        <el-button type="primary" size="mini" round @click="showLogout">
          注销记录
        </el-button>
        <el-button type="primary" size="mini" round @click="batchIdcard"
                   :disabled="idList.length === 0 || auths.indexOf(2) < 0">注册解绑
        </el-button>
        <!--180703应雨生要求暂时注掉，逻辑代码未删除-->
        <!-- <el-button type="primary" size="mini" round @click="batchBank"-->
        <!--:disabled="idList.length === 0 || auths.indexOf(2) < 0">解绑银行卡-->
        <!--</el-button> -->
        <el-button type="primary" size="mini" round @click="batchMarkAgreement"
                   :disabled="idList.length === 0 || auths.indexOf(2) < 0">更改合约状态
        </el-button>
        <el-button type="primary" size="mini" round @click="blacklistDialog = true"
                   :disabled="idList.length === 0 || auths.indexOf(2) < 0">拉黑
        </el-button>
        <el-button type="primary" size="mini" round @click="greylistDialog = true"
                   :disabled="idList.length === 0 || auths.indexOf(2) < 0">加入灰名单
        </el-button>
        <el-button type="primary" size="mini" round @click="getOperationData"
                   :disabled="auths.indexOf(2) < 0">操作记录
        </el-button>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable" :data="tableData" size="small" v-loading="listLoading"
                  element-loading-text="拼命加载中" border tooltip-effect="dark" style="width: 100%"
                  @selection-change="handleSelectionChange" header-row-class-name="table-header">
          <el-table-column type="selection" width="50" align="center" fixed></el-table-column>
          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column prop="idcard" label="身份证" width="160" align="center"
                           :formatter="formatIdCard"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="empPk" label="促销员ID" align="center" width="100"></el-table-column>
          <el-table-column prop="tel" label="手机" width="160" align="center" :formatter="formatTel"></el-table-column>
          <el-table-column prop="portName" label="注册来源" align="center" width="100"></el-table-column>
          <el-table-column prop="signContract" label="是否签约" width="160" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.signContract == 1" style="color: #1652ff; cursor: pointer;"
                    @click="openContractDialog(scope.row.idcard, scope.row.name)">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="bank" label="开户行" width="200" align="center"></el-table-column>
          <el-table-column prop="bankNum" label="银行卡号" width="200" align="center"
                           :formatter="formatBankCard"></el-table-column>
          <el-table-column prop="unionpayNum" label="联行号" width="110" align="center"></el-table-column>
          <el-table-column prop="agreement" label="是否有合约" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.agreement == 1">是</span>
              <span v-if="scope.row.agreement == 2">否</span>
            </template>
          </el-table-column> <!-- 1,2 -->
          <el-table-column prop="emergencyContact" label="紧急联系人" width="100" align="center"></el-table-column>
          <el-table-column prop="emergencyTel" label="紧急联系人手机号" width="160" align="center"
                           :formatter="formatTel1"></el-table-column>
          <el-table-column prop="recommenderName" label="推荐人姓名" width="100" align="center"></el-table-column>
          <!-- recommender 是个类 -->
          <el-table-column prop="recommenderTel" label="推荐人电话号码" width="160" align="center"
                           :formatter="formatTel1"></el-table-column>
          <el-table-column label="身份证照片" width="150" align="center">
            <template slot-scope="scope">
              <div @click="showIdCardDialog(scope.row)" style="display: flex;justify-content:space-around;">
                <div :style="noCompression(scope.row.idcardCover,1)" class="tableImg">
                  <img :src="scope.row.idcardCover || ''" class="table-card-img" alt=""
                       @error="idcardCoverImgTableError">
                </div>
                <div :style="noCompression(scope.row.idcardBack,2)" class="tableImg">
                  <img :src="scope.row.idcardBack || ''" class="table-card-img" alt="" @error="idcardBackTableError">
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="银行卡照片" width="100" align="center">
            <template slot-scope="scope">
              <div @click="showBankCardDialog(scope.row)">
                <img :src="scope.row.bankCover || ''" class="table-card-img" alt="" @error="bankCoverError">
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="autheentication" label="认证状态" width="100" align="center"></el-table-column>
          <el-table-column prop="bankCardAuthentication" label="银行卡 认证状态" width="70" align="center"
                           label-class-name="doubleRow">
            <template slot-scope="scope">
              <span v-if="scope.row.bankCardAuthentication == 0">通过</span>
              <span v-else-if="scope.row.bankCardAuthentication == 1">人工认证</span>
              <span v-else>未通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="authorizeFlag" label="个人信息授权" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.authorizeFlag == 1" style="color: #1652ff; cursor: pointer;"
                    @click="showAuthorize(scope.row.id  , scope.row.name)">已授权</span>
              <span v-else>未授权</span>
            </template>
          </el-table-column>
          <el-table-column prop="qhrStatusName" label="是否qhr人员" width="100" align="center">
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="400">
            <template slot-scope="scope">
              <el-button type="text" size="mini" :disabled="auths.indexOf(1) < 0" @click="viewInfo(scope.row.id)">
                查看详情
              </el-button>
              |
              <el-button type="text" size="mini" :disabled="auths.indexOf(2) < 0" @click="approveByAdmin(scope.row)"
                         style="margin-left: 2px">
                人工实名认证
              </el-button>
              |
              <el-button type="text" size="mini" :disabled="auths.indexOf(2) < 0"
                         @click="bankCardArtificial(scope.row.id)"
                         style="margin-left: 2px">
                人工银行卡认证
              </el-button>
              |
              <el-button type="text" size="mini" :disabled="auths.indexOf(2) < 0" @click="approveReset(scope.row.id)"
                         style="margin-left: 2px">
                认证重置
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>

    <!-- 注册解绑界面 -->
<el-dialog title="注册解绑" :visible.sync="unbindDialog" width="500px" center
               v-loading="approveData.lockApproveDialog" class="approveDialog">
      <div class="dialog-body" style="height: 250px">
        <el-form ref="approveForm" :model="approveData" :inline="true" label-width="120px" class="formInline"
                 size="mini" :rules="rules">
          <el-row style="height: 250px;background-color:#fff">
            <el-form-item prop="applicant" style="margin-top:10px">
              <label class="mylabel"><span class="required">* </span>申请人： </label>
              <el-input v-model="approveData.applicant" placeholder="" :maxlength="20" style="width: 300px;"></el-input>
            </el-form-item>
            <!-- :autosize="{ minRows: 2, maxRows: 2}" resize="none" 文本框禁止修改大小  -->
            <el-form-item prop="applyReason" style="margin-top:20px">
              <label class="mylabel"><span class="required">* </span>申请原因： </label>
              <el-input type="textarea" :rows="2" v-model="approveData.applyReason" placeholder="" :maxlength="200" style="width: 300px;height: 26px"></el-input>
            </el-form-item>
            
            <el-form-item prop="projectCode" style="margin-top:40px">
              <label class="mylabel">所属项目： </label>
              <!-- :filterMethod="filterMethod"  @visible-change="filterMethod('')" -->
              <el-select filterable clearable v-model="approveData.projectCode" placeholder="（项目编号）项目名称" style="width: 300px">
                <el-option style="width:600px" v-for="item in projectDropDownList" :key="item.valueOrgcode" :value="item.valueOrgcode" :label="item.label" />
              </el-select>
            </el-form-item>
            
            <el-form-item prop="orgName" style="margin-top:20px">
              <label class="mylabel">所属部门： </label>
              {{getOptcode("idcard")}}
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="unbindIdCardConfirm"
                   :disabled="approveData.lockConfirm">确 定</el-button>
      </span>
    </el-dialog>

<!-- 认证重置界面 -->
<el-dialog title="认证重置" :visible.sync="resetDialog" width="500px" center
               v-loading="approveData.lockApproveDialog" class="approveDialog">
      <div class="dialog-body" style="height: 250px">
        <el-form ref="approveForm" :model="approveData" :inline="true" label-width="120px" class="formInline"
                 size="mini" :rules="rules">
          <el-row style="height: 250px;background-color:#fff">
            <el-form-item prop="applicant" style="margin-top:10px">
              <label class="mylabel"><span class="required">* </span>申请人： </label>
              <el-input v-model="approveData.applicant" placeholder="" :maxlength="20" style="width: 300px;"></el-input>
            </el-form-item>

            <el-form-item prop="applyReason" style="margin-top:20px">
              <label class="mylabel"><span class="required">* </span>申请原因： </label>
              <el-input type="textarea" :rows="2" v-model="approveData.applyReason" placeholder="" :maxlength="200" style="width: 300px;height: 26px;"></el-input>
            </el-form-item>
            
            <el-form-item prop="projectCode" style="margin-top:40px">
              <label class="mylabel">所属项目： </label>
              <el-select clearable v-model="approveData.projectCode" placeholder="（项目编号）项目名称" style="width: 300px" filterable >
                <el-option style="width:600px" v-for="item in projectDropDownList" :key="item.valueOrgcode" :value="item.valueOrgcode" :label="item.label" />
              </el-select>
            </el-form-item>
            
            <el-form-item prop="orgName" style="margin-top:20px">
              <label class="mylabel">所属部门： </label>
              {{getOptcode("idcard")}}
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="resetConfirm()"
                   :disabled="approveData.lockConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" title="拉黑原因" :visible.sync="blacklistDialog" width="30%" center>
      <div class="dialog-body">
        <el-input type="textarea" class="reason" :rows="6" placeholder="请输入拉黑原因" v-model="reason"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blacklistDialog = false" type="text" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="batchBlack">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="blacklistDialog dialog" title="加入灰名单原因" :visible.sync="greylistDialog" width="30%" center>
      <div class="dialog-body">
        <el-input type="textarea" class="reason" :rows="6" placeholder="请输入拉灰原因" v-model="reason"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="greylistDialog = false" type="text" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="batchGrey">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="cardDialog dialog" title="身份证信息" :visible.sync="idCardDialog" width="780px" center>
      <div class="dialog-body">
        <div class="card-img clearfix">
          <p>身份证号：{{idcardNum}}</p>
          <div style="display: flex;justify-content:space-between;">
            <div @click="viewImage(idcardCoverImg,1)" :style="noCompression(idcardCoverImg,1)" class="dialogImg">
              <img class="floatle" :src="idcardCoverImg || ''" alt="身份证正面照片" @error="idcardCoverError">
            </div>
            <div @click="viewImage(idcardBackImg,2)" :style="noCompression(idcardBackImg,2)" class="dialogImg">
              <img class="floatri" :src="idcardBackImg || ''" alt="身份证背面照片" @error="idcardBackError">
            </div>
          </div>


        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="idCardDialog = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="cardDialog dialog" title="银行卡信息" :visible.sync="bankCardDialog" width="400px" center>
      <div class="dialog-body">
        <div class="card-img">
          <p>开户行：{{bank}}</p>
          <p>银行卡号：{{bankNum}}</p>
          <div @click="viewImage(bankCoverImg,3)" :style="noCompression(bankCoverImg,3)" class="bankImg">
            <img class="bankCardss" :src="bankCoverImg || ''" alt="银行卡照片" @error="bankCoverError2">
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="bankCardDialog = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="cardDialog dialog" title="人员信息" :visible.sync="personInfoDialog" width="1030px" center
               :modal="false">
      <div class="dialog-body">
        <salesperson-info :id="SalespersonId" :auths="auths" v-if="personInfoDialog"></salesperson-info>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="personInfoDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--人工认证弹窗-->
    <el-dialog title="人工认证" :visible.sync="approveDialog" width="1000px" center
               v-loading="approveData.lockApproveDialog" class="approveDialog">
      <div class="dialog-body" style="height: 400px;overflow-y: scroll;">
        <el-form ref="approveForm" :model="approveData" :inline="true" label-width="120px" class="formInline"
                 size="mini" :rules="rules">
          <el-row style="height: 250px">
            <el-form-item prop="newIdcard">
              <label class="mylabel"><span class="required">* </span>身份证号： </label>
              <el-input v-model="approveData.newIdcard" placeholder="请输入身份证号..." :maxlength="18"
                        :disabled="approveData.lockIdCard"></el-input>
            </el-form-item>
            <el-form-item prop="newName">
              <label class="mylabel" style="width: 266px"><span class="required">* </span>姓名： </label>
              <el-input v-model="approveData.newName" placeholder="请输入姓名..." style="margin-left: 2px"></el-input>
            </el-form-item>
            <el-form-item prop="applicant" style="margin-top:20px">
              <label class="mylabel"><span class="required">* </span>申请人： </label>
              <el-input v-model="approveData.applicant" placeholder="" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item prop="projectCode" style="margin-top:20px">
              <label class="mylabel" style="width: 266px">所属项目： </label>
              <el-select filterable clearable v-model="approveData.projectCode" placeholder="（项目编号）项目名称" style="margin-left: 2px" >
                <el-option style="width:600px" v-for="item in projectDropDownList" :key="item.valueOrgcode" :value="item.valueOrgcode" :label="item.label" />
              </el-select>
            </el-form-item>
            <el-form-item prop="applyReason" style="margin-top:20px">
              <label class="mylabel"><span class="required">* </span>申请原因： </label>
              <el-input type="textarea" :rows="7" v-model="approveData.applyReason" :maxlength="200" placeholder="" style="width: 330px;height: 103px;"></el-input>
            </el-form-item>
            <el-form-item prop="orgName" style="margin-top:20px">
              <label class="mylabel" style="width: 117px">所属部门： </label>
              {{getOptcode("idcard")}}
            </el-form-item>
          </el-row>
          <el-row style="height: 50px">
            <el-form-item>
                <label class="mylabel"><span class="required">* </span>身份证有效期： </label>
                <el-date-picker v-model="approveData.idcardValidStart" placeholder="请选择身份有效期开始时间..." value-format="yyyy-MM-dd"></el-date-picker>
                <span>-</span>
                <el-date-picker v-model="approveData.idcardValidEnd" placeholder="请选择身份有效期结束时间..." value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
          </el-row>
          <el-row class="idcardImg">
            <el-col :span="12">
              <el-form-item prop="idCardCover">
                <label class="mylabel"><span class="required">* </span>身份证正面： </label>
                <el-upload
                  class="avatar-uploader"
                  action="/rest/Register/uploadHeadImg"
                  :show-file-list="false"
                  :on-success="idcardCoverUpSucc"
                  :on-error="imgUploadErr"
                  :data="approveData.idCardCoverUpName"
                  @mousedown.native="isUploading = 'idCardCover'"
                  :before-upload="beforeImgUp"
                >
                  <img v-if="approveData.idCardCoverImg" :src="approveData.idCardCoverImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idCardBack">
                <label class="mylabel">示例： </label>
                <img :src="idCardCover_demo" height="200">
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="idcardImg">
            <el-col :span="12">
              <el-form-item prop="idCardBack">
                <label class="mylabel"><span class="required">* </span>身份证反面： </label>
                <el-upload
                  class="avatar-uploader"
                  action="/rest/Register/uploadHeadImg"
                  :show-file-list="false"
                  :on-success="idCardBackUpSucc"
                  :on-error="imgUploadErr"
                  :data="approveData.idCardBackUpName"
                  @mousedown.native="isUploading = 'idCardBack';"
                  :before-upload="beforeImgUp"
                >
                  <img v-if="approveData.idCardBackImg" :src="approveData.idCardBackImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idCardBack">
                <label class="mylabel">示例： </label>
                <img :src="idCardBack_demo" height="200">
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="approveDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="approveConfirm"
                   :disabled="approveData.lockConfirm">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 查看大图 -->
    <div class="viewImage">
      <el-dialog
        title="查看大图"
        :visible.sync="showbigImage"
        v-model="bigImage"
        :width="bigImageWidth2"
        class="dialog"
      >
        <div class="dialogImage" :style="avatarBigImg(bigImage)">
          <img :src="bigImage || ''" alt="" @error="setErrorImage">


        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="showbigImage = false">确 定</el-button>
          <el-button type="primary" size="small" @click="rotate">
            <img style="margin:-7px 5px -5px -5px;"
                 src="../../common/images/rotate.png"
                 alt=""/>
            旋转
          </el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog class="blacklistDialog dialog" title="操作记录查询" :visible.sync="operationLogDialog" width="70%" center
               v-loading="operationLoading">
      <el-form :model="operationLogFormData" :inline="true" label-width="150px" class="formInline" size="mini">
        <div class="slide-wrap" style="height: auto;">
          <el-form-item label="促销员姓名：">
            <el-input placeholder="请输入促销员姓名..." :maxlength="30" v-model="operationLogFormData.salesmanName"/>
          </el-form-item>
          <el-form-item label="促销员身份证号码：">
            <el-input placeholder="请输入促销员身份证号码..." :maxlength="30" v-model="operationLogFormData.idcard"/>
          </el-form-item>
          <el-form-item label="促销员ID：">
            <el-input placeholder="请输入促销员ID..." :maxlength="30" v-model="operationLogFormData.empPk"/>
          </el-form-item>
          <el-form-item label="促销员手机号：">
            <el-input placeholder="请输入促销员手机号..." :maxlength="30" v-model="operationLogFormData.tel"/>
          </el-form-item>
          <el-form-item label="操作类型：">
            <el-select filterable placeholder="请选择操作类型..." v-model="operationLogFormData.operationType">
              <el-option label="请选择" value=""/>
              <el-option label="认证重置" value="1"/>
              <el-option label="人工认证" value="2"/>
              <el-option label="注册解绑" value="3"/>
              <el-option label="银行卡认证" value="4"/>
              <el-option label="注销" value="5"/>
              <el-option label="撤回注销" value="6"/>
              
            </el-select>
          </el-form-item>
          <el-form-item label="操作人：">
            <el-input placeholder="请输入操作人..." :maxlength="30" v-model="operationLogFormData.userName"/>
          </el-form-item>
          <el-form-item label="操作人账号：">
            <el-input placeholder="请输入操作人账号..." :maxlength="30" v-model="operationLogFormData.userAccount"/>
          </el-form-item>
          <el-form-item style="float:right;margin-right: 50px;">
            <el-button class="search-btn" @click="searchOperationData()">筛选</el-button>
            <el-button class="search-btn" @click="exportOperationData()" style="margin-left: 20px;">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="tableBody">
        <el-table class="table-expand" style="width: 100%;" size="small" border :data="operationLogTableData">
          <el-table-column width="100" type="index" label="编号" align="center"/>
          <el-table-column width="110" prop="salesmanName" label="促销员姓名" align="center"/>
          <el-table-column width="110" prop="empPk" label="促销员ID" align="center">
            <template slot-scope="emp">
              <div v-if="emp.row.empPk!='null'">{{emp.row.empPk}}</div>
            </template>
            </el-table-column>
          <el-table-column width="120" prop="wxName" label="微信昵称" align="center"/>
          <el-table-column width="150" prop="idcard" label="促销员身份证号码" align="center">
            <template slot-scope="id">
              <div v-if="id.row.idcard!='null'">{{id.row.idcard}}</div>
            </template>
            </el-table-column>
          <el-table-column width="120" prop="tel" label="促销员手机号" align="center">
            </el-table-column>
          <el-table-column width="150" prop="operationType" label="操作类型" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.operationType == 1">认证重置</div>
              <div v-if="scope.row.operationType == 2">人工认证</div>
              <div v-if="scope.row.operationType == 3">注册解绑</div>
              <div v-if="scope.row.operationType == 4">银行卡认证</div>
              <div v-if="scope.row.operationType == 5">注销</div>
              <div v-if="scope.row.operationType == 6">撤回注销</div>
            </template>
          </el-table-column>
          <el-table-column width="110" prop="applicant" label="申请人" align="center"/>
          <el-table-column width="300" prop="applyReason" label="申请原因" align="center"/>
          <el-table-column width="200" prop="projectName" label="所属项目" align="center"/>
          <el-table-column width="150" prop="orgName" label="所属部门" align="center"/>
          <el-table-column width="150" prop="userName" label="操作人" align="center"/>
          <el-table-column width="150" prop="userAccount" label="操作人账号" align="center"/>
          <el-table-column width="150" prop="operationTime" label="操作时间" align="center"/>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="operationHandleSizeChange"
                       @current-change="operationHandleCurrentChange" :current-page="operationLogFormData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="operationLogFormData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="operationTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog class="approveDialog" title="银行卡认证" :visible.sync="bankCardDialogFlag" width="1000px" :center="true">
      <div class="dialog-body" style="height: 400px;overflow-y: scroll;">
        <el-form :inline="true" label-width="120px" class="formInline" size="mini" :model="bankCardArtificialData" :rules="rules">
          <el-row style="height: 45px">
            <el-form-item>
              <label class="mylabel"><span class="required">* </span>银行卡号码： </label>
              <el-input v-model="bankCardArtificialData.bankNum" placeholder="请输入银行卡号码..." @blur="getBank()"
                        @change="resetBankInfo()"></el-input>
            </el-form-item>
          </el-row>
          <el-row style="height: 45px">
            <el-form-item>
              <label class="mylabel"><span class="required">* </span>开户行： </label>{{bankCardArtificialData.bank}}
            </el-form-item>
          </el-row>
          <el-row style="height: 190px">
            <el-form-item prop="applicant">
              <label class="mylabel"><span class="required">* </span>申请人： </label>
              <el-input v-model="bankCardArtificialData.applicant" placeholder="" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item>
              <label class="mylabel" style="width: 266px">所属项目： </label>
              <el-select filterable clearable v-model="bankCardArtificialData.projectCode" placeholder="（项目编号）项目名称" style="margin-left: 2px" >
                <el-option style="width:600px" v-for="item in projectDropDownList" :key="item.valueOrgcode" :value="item.valueOrgcode" :label="item.label" />
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top:20px">
              <label class="mylabel"><span class="required">* </span>申请原因： </label>
              <el-input type="textarea" :rows="6" v-model="bankCardArtificialData.applyReason" :maxlength="200" placeholder="" style="width: 330px;height: 103px;"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:20px">
              <label class="mylabel" style="width: 117px">所属部门： </label>
              {{getOptcode("bank")}}
            </el-form-item>
          </el-row>
          <el-row style="height: 50px">
            <el-form-item>
              <label class="mylabel"><span class="required">* </span>姓名： </label>{{bankCardArtificialData.salesmanName}}
            </el-form-item>
          </el-row>
          <el-row class="idcardImg">
            <el-form-item>
              <label class="mylabel"><span class="required">* </span>银行卡照片： </label>
              <el-upload
                class="avatar-uploader"
                action="/rest/Register/uploadHeadImg"
                :show-file-list="false"
                :on-success="bankImageOnSuccess"
                :on-error="bankImageOnFailure"
                :data="bankCardArtificialData.bankCoverName"
                :before-upload="verifyBankImage">
                <img v-if="bankCardArtificialData.bankCover && bankCardArtificialData.bankCover != ''"
                     :src="'https://resource.plscn.com/fileupload/' + bankCardArtificialData.bankCover" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="bankCardArtificialCancel">取 消</el-button>
        <el-button type="primary" size="small" @click="bankCardArtificialConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" :title="contractDialogTitle" :visible.sync="showContractDialog"
               width="75%" center v-loading="contractLoading">
      <el-form :inline="true" label-width="150px" class="formInline" size="mini">
        <div class="slide-wrap" style="height: auto;">
          <el-form-item label="合同开始时间">
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.startTimeFrom"
                            type="date"></el-date-picker>
            -
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.startTimeTo"
                            type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同结束时间：">
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.endTimeFrom"
                            type="date"></el-date-picker>
            -
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.endTimeTo" type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称：">
            <el-select v-model="contractFormData.customer" filterable placeholder="请选择...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in customerList" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约平台：">
            <el-select v-model="contractFormData.serviceSupplier" filterable placeholder="请选择..." clearable>
              <el-option label="不限" :value="null"></el-option>
              <el-option label="薪太软" value="薪太软"/>
              <el-option label="众简" value="众简"/>
            </el-select>
          </el-form-item>
          <el-form-item style="float:right;margin-right: 50px;">
            <el-button class="search-btn" @click="searchContractData()">筛选</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="tableBody">
        <el-table class="table-expand" style="width: 100%;" size="small" border :data="contractData">
          <el-table-column type="index" label="编号" align="center"/>
          <el-table-column prop="customer" label="签约客户" align="center"/>
          <el-table-column prop="merchantName" label="供应商" align="center"/>
          <el-table-column prop="signTime" label="签约时间" align="center"/>
          <el-table-column prop="startTime" label="合同开始时间" align="center"/>
          <el-table-column prop="endTime" label="合同结束时间" align="center"/>
          <el-table-column prop="serviceSupplier" label="签约平台" align="center"/>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleContractSizeChange"
                       @current-change="handleContractCurrentChange" :current-page="contractFormData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="contractFormData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="contractTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" :title="authorizeDialogSalesmanName" :visible.sync="authorizeDialogFlag"
               width="1030px" center>
      <div class="tableBody">
        <el-table class="table-expand" style="width: 100%;" size="small" border :data="authorizeDialogList">
          <el-table-column type="index" label="编号" align="center"/>
          <el-table-column prop="authorizeType" label="授权协议名称" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.authorizeType == 1" style="color: #1652ff; cursor: pointer;"
                    @click="authorizeDialog1 = true">个人信息授权协议</span>
              <span v-else-if="scope.row.authorizeType == 2" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog2 =true">个人信息授权协议2020版</span>
              <span v-else-if="scope.row.authorizeType == 3" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog3 =true">隐私政策2021</span>
              <span v-else-if="scope.row.authorizeType == 4" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog4 =true">隐私政策2021-2</span>
              <span v-else-if="scope.row.authorizeType == 5" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog5 =true">平台用户服务协议</span>
              <span v-else-if="scope.row.authorizeType == 6" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog6 =true">隐私政策2022</span>
              <span v-else-if="scope.row.authorizeType == 7" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog7 =true">个人信息采集授权</span>
              <span v-else-if="scope.row.authorizeType == 8" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog8 =true">人脸识别服务授权</span>
              <span v-else-if="scope.row.authorizeType == 9" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog9 =true">身份信息识别服务授权</span>
              <span v-else-if="scope.row.authorizeType == 10" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog10 =true">银行信息识别服务授权</span>
              <span v-else-if="scope.row.authorizeType == 11" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog11 =true">地理信息采集授权</span>
              <span v-else-if="scope.row.authorizeType == 12" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog12 =true">隐私政策</span>
              <span v-else-if="scope.row.authorizeType == 13" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog13 =true">DP免责规范及自我声明</span>
              <span v-else-if="scope.row.authorizeType == 14" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog14 =true">DP免责规范及自我声明V2</span>
              <span v-else-if="scope.row.authorizeType == 15" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog15 =true">RS免责规范及自我声明</span>
              <span v-else-if="scope.row.authorizeType == 16" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog16 =true">个人视频共享授权</span>
              <span v-else-if="scope.row.authorizeType == 17" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog12 =true">隐私政策（202404）</span>
              <span v-else-if="scope.row.authorizeType == 18" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog18 =true">小程序-隐私政策</span>
              <span v-else-if="scope.row.authorizeType == 19" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog19 =true">小程序-服务协议</span>
              <span v-else-if="scope.row.authorizeType == 20" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog20 =true">小程序-人脸识别服务授权</span>
              <span v-else-if="scope.row.authorizeType == 21" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog21 =true">小程序-身份信息识别服务授权</span>
              <span v-else-if="scope.row.authorizeType == 22" style="color: #1652ff; cursor: pointer;" @click="authorizeDialog22 =true">小程序-银行信息识别服务授权</span>
              <!-- <span v-else style="color: #1652ff; cursor: pointer;" @click="authorizeDialog4 =true">隐私政策2021-2</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="authorized" label="是否授权" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.authorized">已授权</span>
              <span v-else>未授权</span>
            </template>
          </el-table-column>
          <el-table-column prop="authorizeTime" label="授权开始时间" align="center"/>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change=""
                       @current-change="1" current-page="1"
                       :page-sizes="[10, 20, 50, 100]" page-size="10"
                       layout="slot,sizes, total,  prev, pager, next, jumper" total="2">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="authorizeDialogFlag = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="blacklistDialog dialog" title="个人信息授权协议" :visible.sync="authorizeDialog1"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">合规采集个人信息相关条款</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
一、信息收集的种类与目的
本公司需因下列原因向您收集下列信息：
1、为了对您的身份进行认证、并与eHR系统米咖对接，便于对您的日常工作进行管理，本公司将收集您的姓名、手机号、身份证号、照片、刷脸视频（调用腾讯优图接口）；
2、为了与您结算并向您支付项目费用，本公司将收集您的银行卡号、银行卡照片。

二、信息的使用
为了满足公司日常运营的需要，并为了遵守国家法律法规及监管要求，本公司会在以下情形中使用您的信息：
1、实现上述第一条“信息收集的种类与目的”所述目的；
2、根据法律法规或监管要求向相关部门进行报告。

三、信息收集及使用的确认
1、本公司已经向您充分披露了将收集您的信息的事实，并充分披露了向您收集的信息的种类、目的；
2、您向本公司提供的第一条列示的信息均系自愿提供；
3、您同意本公司按照第二条约定目的使用您提供的全部信息；
4、本公司按照第一条收集您的信息、按照第二条使用您的信息不构成对您个人隐私的任何侵犯，您与本公司不会因为对您信息的收集及使用产生任何纠纷。
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="blacklistDialog dialog" title="个人信息授权协议2020版" :visible.sync="authorizeDialog2"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">合规采集个人信息相关条款</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
一、信息收集的种类与目的
本平台需因下列原因向您收集下列信息：
1、	为了对您的身份进行认证、并与eHR系统米咖对接，便于对您的日常工作进行管理，本公司将收集您的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等；
2、	为了与您结算并向您支付项目服务费，本公司将收集您的银行卡号、银行卡照片。

二、信息的使用
为了满足平台日常运营的需要，并为了遵守国家法律法规及监管要求，本平台会在以下情形中使用您的信息：
1、实现上述第一条“信息收集的种类与目的”所述目的；
2、根据法律法规或监管要求向相关部门进行报告；
3、征得您同意的其他用途。

三、信息收集及使用的确认
1、	本平台已经向您充分披露了将收集您的信息的事实，并充分披露了向您收集的信息的种类、目的；
2、	您向本平台提供的第一条列示的信息均系自愿提供，并确保您所提供的信息的真实、完整、准确和及时；
3、	您同意本平台按照第二条约定目的使用您提供的全部信息；
4、	本平台按照第一条收集您的信息、按照第二条使用您的信息不构成对您个人隐私的任何侵犯，您与本公司不会因为对您信息的收集及使用产生任何纠纷。
5、	本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等。披露给合作中的促销活动品牌方。
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="blacklistDialog dialog" title="隐私政策2021" :visible.sync="authorizeDialog3"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">隐私政策2021</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。

我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。

一、我们如何收集和使用您的个人信息

个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。

为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括：

1、您提供的信息

当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全：

用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像、指纹识别；

用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； 

用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌；

电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。

您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。

2、您在使用服务过程中产生的信息 

您使用我们提供的服务时，我们可能自动收集以下信息： 

（1）日志信息 
指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： 

A. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； 

B. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； 

（2）位置信息 

指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。

（3）手机账户信息 

指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  

3、业务功能需要获取的相关权限信息 

当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：

（1）语音搜索：需要音频权限、语音识别权限； 

（2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； 

（3）实名制功能：相册、相机权限； 

（4）图片缓存加速、日志或附件存储到本地：本地存储权限； 

（5）分享功能：需要发送短信权限； 

（6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；

（7）在线客服语音输入：音频权限； 

（8）在线客服拍照反馈：相机、相机权限； 

（9）在线客服转人工：拨打电话权限； 

（10）在线客服照片反馈：相册、相机权限

4、第三方收集和使用信息

（1）第三方服务收集信息的情形 

在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。

（2）从第三方获得您的个人信息 

为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。

二、我们可能将收集到的您的个人信息用于以下目的：

1、为您提供服务 

（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； 

（2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； 

（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； 

（4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； 

（5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； 

（6）软件认证或管理软件升级； 

（7）让您参与有关我们产品和服务的调查； 

（8）其他您授权同意提供个人信息的情况。

2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 

3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 

4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： 

（1）与国家安全、国防安全有关的； 

（2）与公共安全、公共卫生、重大公共利益有关的 

（3）与犯罪侦查、起诉、审判和判决执行等有关的； 

（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 

（5）所收集的个人信息是个人信息主体自行向社会公众公开的； 

（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； 

（7）根据您的要求签订合同所必需的； 

（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； 

（9）为合法的新闻报道所必需的； 

（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； 

（11）法律法规规定的其他情形。

三、个人信息的存储 

（1）信息存储的地点 

我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。

（2）信息存储的期限 

我们承诺您个人信息的存储时间始终处于合理必要期限内<b>（原则上5年）</b>，我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，<b>我们将以推送通知、公告形式通知您</b>，并在合理的期限内删除您的个人信息或进行匿名化处理。
 
四、个人信息安全保护措施和能力 

1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。<b>我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。</b>我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。  

<b>2、注销平台服务功能 </b>

您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。

五、我们如何共享、转让、公开披露您的个人信息 

<b>（一）共享 </b>

我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： 

1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 

2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 

3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 
我们的关联公司包括<b>米咖平台</b>现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 

4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： 

A.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 

B.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 

C.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 

（二）转让 

我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： 

1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； 

2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 

（三）公开披露 

我们仅会在以下情况下，公开披露您的个人信息： 

1、获得您明确同意后； 

2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。

六、我们如何保护您的个人信息 

（一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 

（二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  

（三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。<b>本APP在上线前已通过企业级安全加固技术进行加壳，确保程序安全稳定。</b>但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 

七、您的权利 

1、查询和更正您的个人信息 

除法律法规规定外，您有权在登陆本平台后查询<b>您的个人信息。</b>

2、在以下情形中，您可以向我们提出删除个人信息的请求： 

（1）如果我们处理个人信息的行为违反法律法规； 

（2）如果我们收集、使用您的个人信息，却未征得您的同意； 

（3）如果我们处理个人信息的行为违反了与您的约定； 

（4）如果您不再使用我们的产品或服务，或您注销了账号；

（5）如果我们不再为您提供产品或服务。 

当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。

八、本政策如何更新 

我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 

九、争议解决

因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。
          </span>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" title="隐私政策2021-2" :visible.sync="authorizeDialog4"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">隐私政策2021-2</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
发布时间：2021年1月28日
更新时间：2021年10月19日
米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。
我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。
一、我们如何收集和使用您的个人信息 
个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 
为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括： 
1、您提供的信息 
当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全： 
用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像、指纹识别； 
用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； 
用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌； 
电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。
您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。 
2、您在使用服务过程中产生的信息 
您使用我们提供的服务时，我们可能自动收集以下信息： 
（1）日志信息 
指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： 
A. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； 
B. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； 
（2）位置信息 
指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。
（3）手机账户信息 
指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  
3、业务功能需要获取的相关权限信息 
当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：
（1）语音搜索：需要音频权限、语音识别权限； 
（2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； 
（3）实名制功能：相册、相机权限； 
（4）图片缓存加速、日志或附件存储到本地：本地存储权限； 
（5）分享功能：需要发送短信权限； 
（6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；
（7）在线客服语音输入：音频权限； 
（8）在线客服拍照反馈：相机、相机权限； 
（9）在线客服转人工：拨打电话权限； 
（10）在线客服照片反馈：相册、相机权限

4、第三方收集和使用信息
（1）第三方服务收集信息的情形 
在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。
（2）从第三方获得您的个人信息 
为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。

二、我们可能将收集到的您的个人信息用于以下目的： 
 1、为您提供服务 
（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； 
（2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； 
（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； 
（4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； 
（5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； 
（6）软件认证或管理软件升级； 
（7）让您参与有关我们产品和服务的调查； 
（8）其他您授权同意提供个人信息的情况。
 2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 
3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 
4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： 
（1）与国家安全、国防安全有关的； 
（2）与公共安全、公共卫生、重大公共利益有关的 
（3）与犯罪侦查、起诉、审判和判决执行等有关的； 
（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 
（5）所收集的个人信息是个人信息主体自行向社会公众公开的； 
（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； 
（7）根据您的要求签订合同所必需的； 
（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； 
（9）为合法的新闻报道所必需的； 
（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； 
（11）法律法规规定的其他情形。 

三、个人信息的存储 
（1）信息存储的地点 
我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。 
（2）信息存储的期限 
我们承诺您个人信息的存储时间始终处于合理必要期限内（原则上5年），我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。 
四、个人信息安全保护措施和能力 
1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。 您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。
五、我们如何共享、转让、公开披露您的个人信息 
（一）共享 
我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： 
1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 
2、与我们合作中的促销活动品牌方共享：本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等，披露给合作中的促销活动品牌方，并允许品牌方使用。
3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 
4、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 
我们的关联公司包括米咖平台现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 
5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： 
A.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 
B.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 
C.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 
（二）转让 
我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： 
1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； 
2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 
（三）公开披露 
我们仅会在以下情况下，公开披露您的个人信息： 
1、获得您明确同意后； 
2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 
六、我们如何保护您的个人信息 
（一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 
（二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  
（三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 
七、您的权利 
1、查询和更正您的个人信息 
除法律法规规定外，您有权在登陆本平台后查询您的个人信息。
2、在以下情形中，您可以向我们提出删除个人信息的请求： 
（1）如果我们处理个人信息的行为违反法律法规； 
（2）如果我们收集、使用您的个人信息，却未征得您的同意； 
（3）如果我们处理个人信息的行为违反了与您的约定； 
（1）如果您不再使用我们的产品或服务，或您注销了账号； 
（2）如果我们不再为您提供产品或服务。 
当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
八、本政策如何更新 
我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 
九、争议解决
因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。
          </span>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="blacklistDialog dialog" title="平台用户服务协议" :visible.sync="authorizeDialog5"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">平台用户服务协议</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
          版本发布时间：【20220101】； 
版本更新时间：
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;欢迎您使用米咖平台向您提供的各项服务！以下简称“平台” 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在使用本平台所提供的服务前，应当仔细认真阅读本《平台用户服务协议》(以下简称“本协议”)中的全部规则、及平台不时发布或更新的其他服务条款、专项产品或服务规则或规范（包括但不限于《平台规则及违约责任条款》，以下合称“服务规则”）的内容（特别是其中以黑体字标示出的关于平台及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议 解决条款，请您重点阅读），确认对本条款、《平台用户服务协议》 及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用平台或以其他方式使用或接受平台的任何服务，即视为您已阅读并与平台达成协议，自愿接受本条款的所有内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。
本条款的签约双方为本平台的实际开发商上海若胜米咖信息技术有限公司及集团公司与使用平台服务的您（下称“您”），本条款是您与本平台之间关于您使用平台入驻服务商之间发布的任务服务所订立的服务条款， 具有正式书面合同的效力。 
如本条款与《平台用户服务协议》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本协议为准。本协议有待明确、存在歧义或未规定之处均以《平台用户服务协议》中的规定为准。 
您理解并同意，平台将根据本条款及《平台用户服务协议》的规定及商业因素，对本协议条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《平台用户服务协议》的相关约定。变更后的协议和规则一经在平台公布后，立即自动生效。如您不同意相关变更，应当立即停止使用平台服务。您继续使用平台服务的，即表示您接受经修订的协议和规则。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、定义 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1 平台任务：即平台，是指平台入驻方（以下简称第三方）提出的任务发布服务，并通过该平台展示出行费用及服务完成确认等信息的互联网技术平台。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2 信息服务：平台利用电脑、服务器、互联网、电话、移动设备等信息通讯设备，向您展示订单，促成您与需求方达成服务合作。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.3 任务订单：登记第三方具体需求信息任务的电子订单。您按照平台的要求提供的抢单、签约、激活订单等信息，全部信息作为一个整体构成一个订单。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、账号注册与使用 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.1 您知悉并同意，您可通过注册新的账号或登录您现有的账号以使用为第三方所提供的服务，并应遵守《平台用户服务协议》中的各项规定。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.2 您确认，在您完成注册程序或以其他平台允许的方式实际使用平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且平台有权注销或永久冻结您的账号，并保留向您及您的监护人索偿的权利。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.3 您承诺向平台所提供的信息真实、准确、完整。平台有权要求您提供各项信息文件，并验证其真实性，当查验您提供的信息可能缺乏真实性、准确性时，平台有权进一步要求您提供其他证明文件或拒绝向您提供服务或拒绝您使用有关网站、服务、应用程序。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.4 您应是您注册账号的唯一授权使用人，可根据自己的需求使用，但不得以任何形式将账号转让或出借他人使用。未经平台授权同意，您也不得将账号相关的权利义务转让给他人。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.5 鉴于网络服务的特殊性，除您第三方使用平台服务时外，平台无义务审核是否是用户本人使用该账号，仅审核用户身份识别信息是否与数据库中保存的一致，所以即使用户认为账号登录行为并非用户本人所为，平台将不承担因此而产生的任何责任。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、服务规范 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.1 您在使用平台服务时，除了应当遵循诚实信用原则，遵守法律法规、所在服务单位的政策以及规章制度外，还应当遵守本协议、《平台用户服务协议》及服务规则的各项规定。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.2 平台根据您的服务状态向您提供第三方任务、订单信息等，您可自主选择是否处于服务状态。如您接受订单，您应按照订单需求为第三方提供服务，并遵守本条款约定的平台规则。您可通过下载并安装到移动设备上的平台提供的应用程序或其他方式选择并使用平台信息服务。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.3 本平台的运营权归普乐师（上海）数字科技有限公司所有。平台向您提供的是信息服务，而非通讯服务，您在使用平台提供的服务时，应具备可以安装平台相关应用程序的终端设备。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.4 您与平台合作为第三方提供服务的时间为订单成立且您准备提供服务的时间。在非合作期间，平台并不要求您继续为第三方提供服务。如因其他原因需要继续服务，则该服务行为属于您的个人行为与本平台无关。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.5 您注册和使用本平台过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等您所发送、回复或自动回复消息和相关链接页面，以及其他使用用户账号或本平台产生的内容均不得违反现行法律、法规、规章、政策规定；如果您在境外使用本平台，应同时遵守所在地或相关国家（地区）的法律法规。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6 您不得利用本平台制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.1 反对宪法所确定的基本原则的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.3 损害国家荣誉和利益的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.4 煽动民族仇恨、民族歧视，破坏民族团结的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.5 破坏国家宗教政策，宣扬邪教和封建迷信的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.6 散布谣言，扰乱社会秩序，破坏社会稳定的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.8 侮辱或者诽谤他人，侵害他人合法权益的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6.9 含有法律、行政法规禁止的其他内容的信息。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7 您不得利用本平台制作、上载、复制、发布、传播如下干扰平台正常运营，以及侵犯其他用户或第三方合法权益的内容：
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.1 含有任何性或性暗示的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.2 含有辱骂、恐吓、威胁内容的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.3 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.4 涉及他人隐私、个人信息或资料的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.5 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7.6 含有其他干扰本平台正常运营和侵犯其他用户或第三方合法权益内容的信息。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8 您不得利用本平台进行如下行为：
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.1 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.2 虚构事实、隐瞒真相以误导、欺骗他人的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.3 利用技术手段批量建立虚假账号的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.4 利用本平台从事任何违法犯罪活动的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.5 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8.6 其他违反法律法规规定、侵犯其他用户合法权益、干扰本平台正常运营或本平台未明示授权的行为。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9 承诺与保证 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9.1 除遵守本条款、《平台用户服务协议》及服务规则外，您应进一步保证您符合从事社会服务的相关标准，包括但不限于您满足服务地城市、相关法律法规规定的户籍或居住证等有关要求，无限制从业的相关疾病，并符合以下条件： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9.1.1 年龄：18-60周岁；普通话标准；无犯罪记录、无吸毒记录、无精神病史，未列入公安部门不良记录。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9.1.2身体健康，外露皮肤无明显疤痕、纹身，无怪异发型(颜色），无传染性疾病；无下列可能影响服务的疾病：器质性心脏病；癫痫病；美尼尔氏症；眩晕症；癔病；震颤麻痹；精神病；痴呆以及影响肢体活动的神经系统疾病；妨碍安全服务疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）;长期服用依赖性精神药品成瘾尚未戒除的。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9.2 如您未满足以上标准或要求，平台有权立即终止与您的合作。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.10 您在浏览、访问或使用平台产品及服务时可能以各种形式获取、知悉与平台或第三方有关的秘密信息（包括但不限于第三方信息、平台及其关联公司的运营或财务信息等）。为更好地保护您、第三方及我们的合法权益，您将严格遵守保密义务，不会在任何时间以任何方式窃取、泄露前述秘密信息。如果您发生本条款禁止行为，我们将会采取相应措施，包括但不限于中止或终止向您提供任何产品或服务、要求您承担损害赔偿责任；如果您的行为构成犯罪，将被追究相应的刑事责任。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.11 费用支付 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.11.1 平台有权制定相关费用结算标准并不时更新予以公示，具体订单结算适用订单发生时公示的结算标准。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.11.2 如您使用第三方支付系统从服务单位处收取结算的费用，应由您自行开通第三方支付系统服务（包括但不限于平台支付、微信支付、支付宝等）。您在使用第三方支付时，除了受到本条款的约束之外，还要受电子支付服务商及信用卡/借记卡发卡行的条款和政策的约束。平台不为第三方提供的服务承担责任。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.11.3 您可以随时通过平台查询订单情况，您应在每次服务完成后及时核对订单信息。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.12 您在平台中或通过平台所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本平台的观点、立场；您不得以平台的名义传送或发布信息；也不得以易被公众或第三方混淆为平台官方意见的方式传送或发布信息。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、风险承担 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.1 您在使用平台的过程中，将会涉及到第三方提供的地图及导航等服务，请您务必在确保安全的前提下使用上述服务，以防发生其他危险情况。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2 平台向您提供信息技术服务，对于您给第三方提供的服务过程中产生的风险不承担责任，但法律法规另有强制性规定的除外。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.3 平台与您合作向第三方提供的服务，双方关系受《中华人民共和国民法典》等民事法律的约束。平台与您之间不构成任何直接或间接的劳动关系，不适用 《劳动法》《劳动合同法》《社会保险法》《住房公积金管理条例》等法律法规。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、对您信息的管理及限制 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.1 您知悉、理解并同意，在您使用平台时，您同意平台依据《平台隐私政策》的规定执行相关个人信息的收集、使用和共享。平台亦有权应政府部门（包括司法及行政部门）的要求，向其提供您的相关信息。此外，您知悉并认可：平台可能会与第三方合作而向您提供相关的功能，在此情况下，如该第三方同意承担与平台同等的保护您隐私的责任，则平台有权将您的相关资料等提供给该第三方。另外，在不透露您隐私资料的前提下，平台有权对与您账号相关的整个数据库进行分析并对相关的数据库进行商业上的利用。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.2 您被平台终止服务或账号被注销后，平台没有义务为您保留或向您披露账号中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.3 您同意，平台停止向您提供服务后，平台仍享有下列权利： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.3.1 继续保存您未及时删除的信息及使用平台期间发布的所有信息至法律规定的记录保存期满。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.3.2 您在使用期间存在违法行为或违反本条款和/或服务规则的行为的，平台仍可依据本条款向您主张权利。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;六、知识产权 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.1 平台所展示的各运营系统由本平台自主开发、运营提供技术支持，并对平台服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。平台提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归平台所有。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.2 您理解并同意：您在使用平台过程中所产生、上传的内容等所有信息的知识产权及所有权，适用《平台用户服务协议》中的相关约定。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;七、责任限制声明 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.1 您确认，您在使用平台为平台第三方所提供的服务时，应当具备中华人民共和国法律规定的完全民事权利能力和民事行为能力。否则您及您的监护人应依照法律规定承担因此而导致的一切后果，在该等情形下，平台有权立即注销您的账号或停止向您提供服务，您应就由此给平台造成的所有损失予以赔偿。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.2 您应谨慎合理的保存、使用用户名和密码，并对通过您的账号和密码实施 的所有行为、活动及事件负全责。您若发现任何不当使用账号或存在安全漏洞等其他可能危及您账号安全的情况，应立即依照《平台用户服务协议》的相关规定采取措施并予以处理。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.3 由于您的过错给平台第三方或其他第三方造成侵权损害，应当由您承担相应的赔偿责任，对于由于您的过错造成的侵权损害或您因违约给平台造成的损失，平台有权向您追偿。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.4 如您在使用平台的过程中发现平台中的相关服务信息违反法律规定，您可及时向平台或有关机关举报或投诉，平台将在收到您的举报或投诉时采取相应的核实与处理措施。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.5 平台在为您提供服务时，可能会引入平台范围之外的第三方服务商提供的服务（第三方签约服务、支付服务、查询服务等）。您知悉、理解并同意，您使用平台号访问或使用第三方服务商提供的服务时将跳转至第三方服务商的独立平台。第三方服务商并非本平台，亦不通过本平台向您提供任何服务或达成任何交易。因此，本平台无法实质审核、控制第三方服务商及其所提供的具体服务或对第三方服务予以任何形式的担保或承诺。您应在访问或使 用第三方服务商的服务前应自行核实第三方服务商的身份、资质、服务内容等 相关信息，仔细约定第三方服务商的相关服务协议或规则，并自行选择是否进行本条款下的授权操作并使用本平台账号接受相关第三方服务商服务，本平台将不就您所接受的第三方服务商服务向您承担任何责任。您拟接受的第三方服务商服务将由该第三方服务商独立运营并独立承担全部责任。因该第三方服务所产生的纠纷，或第三方服务商违反相关法律法规或本条款约定，或您在使用第三方服务过程中遭受的损失，请您根据与第三方服务商所订立的相关服务协议等相应协议或规则，联系第三方服务商予以解决。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.6 对于来源于外部的风险，比如违法犯罪活动、交通事故等意外事件等造成的损失，由相关责任方承担，本平台将会积极协助相关部门进行处理。对于您在提供平台服务过程中发生的不可抗力事件，本平台将会在合理范围内进行协助解决。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.7 您同意并确认，本平台拥有独自决定拒绝向您提供服务的权利。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.8 您同意本平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知信息的权利。此外，您允许本平台依照《平台用户服务协议》及《平台隐私政策》的相关规定向您发送商业性电子信息或广告促销信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.9 您不得在本平台上发布不良违法信息以及与本平台提供服务无关的信息、或发布《平台用户服务协议》中规定的其他禁止用户发布的信息或从事其他违反《平台用户服务协议》规定的行为，否则本平台有权随时永久停止向您提供服务，由此产生的一切责任应由您自行承担。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.10 不论在何种情况下,本平台对由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;八、通知的发送 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.1 您同意本条款项下本平台对于您所有的通知（包括商品信息或商业性广告）均可通过网页公告、客户端推送消息、发送到用户注册的电子邮件、手机或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人，以上通知模式均具有同样的法律效力。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.2 您对于本平台的通知应当通过本平台对外正式公布的通信地址、传真 号码、电子邮件地址等联系信息进行送达。该等通知以本平台实际收到日为送达日。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九、条款的终止 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.1 本平台有权终止向您提供服务，本条款于全部服务依法定程序及方式终止之日终止。 9.2 本条款的终止不影响本平台其他主体依据本条款享有的各项权利的实现，也不影响守约方向违约方追究违约责任。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;十、争议解决 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.1 如您与本平台第三方服务发生任何争议，平台可在法律法规要求的范围内协助您与平台第三方之间争议的协商调解。您同意，本平台有权通过电话或电子邮件等方式向争议双方了解情况，并将所了解的情况通过必要方式通知对方。此外，您有权通过司法或执法机关要求本平台提供相关资料，但您理解并同意，本平台无任何义务对您与服务单位之间的任何争议承担任何责任。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.2 若您与平台因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向平台主体公司所在地上海市普陀区人民法院提起诉讼。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.3 因您使用本平台服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。您在使用我公司应用程序并通过该应用程序接单或服务平台第三方，即视为您已充分理解并与平台服务商之间签署的服务条款。并在此前提下同意接受本条款中约定的平台规则及违规责任。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、如您存在下列违反平台规则的行为，应当按照本条款约定承担违规责任。违规责任包括违约金、暂停服务或解除合作。在您接到投诉的情况下，平台有权进行调查，调查期间将暂停对您的平台服务。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、您在使用本平台服务时，不得有下列破坏平台规则，损害平台第三方、其他平台用户及平台利益的作弊行为。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 利用虚假的账号，以获取奖励、订单、好评等为目的的作弊行为 （如：伪造账号接单、团伙刷单、模拟刷单、自己或串通他人伪造第三方账号以骗取平台奖励等）。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 安装使用对平台产生干扰的设备或第三方作弊软件的行为。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3 短时间内完成多个订单且订单金额不在正常交易范围内的订单/订单金额异常。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4 其他作弊违规行为。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、违反平台规则，应当承担以下违约责任。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 平台判定您在服务过程中存在不规范操作行为（如：接单后不执行、爽约、违约等）的， 平台有权立即暂停该账号接单 24小时；不规范行为同时违反本条款第一条的，平台也有权按照第一条的规定，要求您承担违规责任。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 违反本条款第二条规定的，平台有权暂停该账号一切活动，包括关于该账号的费用结算。同一账号第一次被判定为作弊的，平台有权暂停该账号接单3天，第二次被判定为作弊的，平台有权暂停该账号接单7天；第三次及以上被判定为作弊的，平台有权暂停该账号接单30天。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3 平台有权不结算作弊订单或收回已结算作弊订单的金额，并收取相当于作弊订单金额三倍的违约金。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、您理解并同意，因您违反本协议约定或发生其它过错，导致或产生的任何第三方向平台或其合作方、关联方主张任何索赔、要求，如果造成平台或其合作方、关联方发生的任何损失，包括合理的律师费，您应当向平台与合作方、关联方承担赔偿责任。平台可以协助合作方、关联方向您主张权利。
          </span>
        </div>
      </div>
    </el-dialog>

        <el-dialog class="blacklistDialog dialog" title="隐私政策2022" :visible.sync="authorizeDialog6"
               width="1030px" center>
      <div style="font-size: 15px;padding: 10px;text-align: left;">
        <div style="">
          <h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">隐私政策2022</h3>
        </div>
        <div style="overflow-y: scroll;max-height: 400px;">
          <span style="white-space: pre-line;padding: 0 5px;">
                   发布时间：2021年1月28日
更新时间：2022年1月10日
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;米咖非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。本政策适用于米咖平台所提供的服务，请您在使用本平台服务前，仔细阅读并了解本《隐私政策》。 当您按照米咖平台注册页面提示阅读并同意本政策且完成全部注册程序后，即表示您已充分阅读、理解并接受本政策的全部内容。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们承诺，米咖仅会出于本政策所述的以下目的，收集和使用您的个人信息。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、我们如何收集和使用您的个人信息： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为更好地为您提供服务，米咖将遵循“合法、正当、必要”原则，按照法律法规的规定和您的同意收集您的个人信息，主要包括： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、您提供的信息 
当在你使用本平台服务的过程中，本平台会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的账号安全： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b> 用户个人基本信息：姓名（名称）、性别、年龄、常用地址、地理位置、电话号码、电子邮箱地址、身份证件号码、证件照片、用户人像； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户权限信息：通讯录权限、相册权限、相机权限、存储权限、读取权限、蓝牙权限、音频权限、定位权限、拨打电话权限、获取应用列表权限、语音识别权限、短信验证码； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户终端信息：设备MAC地址、唯一设备识别码、SIM卡IMSI信息、IMEI、终端版本型号、网络IP、本机号码、网络类型、手机品牌； 
电子商务信息：家庭住址、身份证、面部特征、开户行名称、银行卡卡号、银行卡有效期限、银行预留手机号码。</b>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您提供的上述信息，将在您使用本平台服务期间持续授权我们使用。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、您在使用服务过程中产生的信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您使用我们提供的服务时，我们可能自动收集以下信息： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）日志信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A. 设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;B. 您在使用我们服务时搜索和浏览的信息，例如您使用的搜索关键字、访问页面，以及您在使用我们服务时浏览或要求提供的其他信息； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）位置信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指您开启设备定位功能并使用我们基于位置提供的相关服务时，我们收集的有关您位置的信息，例如您通过具有定位功能的移动设备使用我们的服务时，我们通过 GPS 或 WiFi等方式收集的您的地理位置信息。您可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）手机账户信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号相关信息。  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、业务功能需要获取的相关权限信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当在你使用米咖平台服务的过程中，米咖平台需要获取您的手机相关权限，用以向你提供服务、优化我们的服务以及保障你的账号安全：
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）语音搜索：需要音频权限、语音识别权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）投诉处理图片上传、保存邮件中的图片到本地相册、发送邮件时选择相册中的图片作为附件、保存米咖平台中的图片至本地相册：需要相册、相机权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）实名制功能：相册、相机权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）图片缓存加速、日志或附件存储到本地：本地存储权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）分享功能：需要发送短信权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（6）一键登录、活跃数据统计、云闪付：读取电话状态（IMSI/IMEI号）权限；
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（7）在线客服语音输入：音频权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（8）在线客服拍照反馈：相机、相机权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（9）在线客服转人工：拨打电话权限； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（10）在线客服照片反馈：相册、相机权限

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、第三方收集和使用信息
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）第三方服务收集信息的情形 
在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务 。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）从第三方获得您的个人信息 
为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、我们可能将收集到的您的个人信息用于以下目的： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、为您提供服务 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）通过信息数据分析，帮助我们设计新服务，改善我们现有服务； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）使我们更加了解您如何使用我们的服务，从而针对性地满足您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）提供您关注或者与您相关的广告以替代普遍投放的广告，您在使用我们的服务时，我们可能使用您的信息向您发送电子邮件、短信或推送通知，如您不希望收到这些信息，可以按照我们的相关提示取消订阅； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）评估我们服务中的广告和其他促销及推广活动的效果，并加以改善； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（6）软件认证或管理软件升级； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（7）让您参与有关我们产品和服务的调查； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（8）其他您授权同意提供个人信息的情况。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告。基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）与国家安全、国防安全有关的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）与公共安全、公共卫生、重大公共利益有关的 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）与犯罪侦查、起诉、审判和判决执行等有关的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）所收集的个人信息是个人信息主体自行向社会公众公开的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（7）根据您的要求签订合同所必需的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（9）为合法的新闻报道所必需的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（11）法律法规规定的其他情形。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、个人信息的存储 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）信息存储的地点 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）信息存储的期限 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们承诺您个人信息的存储时间始终处于合理必要期限内（原则上5年），我们根据业务需要时长去存储用户信息，超出保存期限的用户信息，米咖平台会做匿名化处理；当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、个人信息安全保护措施和能力 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解你设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知你。 您在本平台登录时的用户名为您的手机号码，本平台只通过关联方式展示该手机号码的信息。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、我们如何共享、转让、公开披露您的个人信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）共享 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们不会与您在米咖平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、与我们合作中的促销活动品牌方共享：本人同意平台将本人信息，包含但不限于本人的姓名、出生日期、身份证件号码、生物识别信息（包括但不限于照片、刷脸视频等）、住址、电话号码、电子邮箱、健康信息、行踪信息等，披露给合作中的促销活动品牌方，并允许品牌方使用。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的关联公司包括米咖平台现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的网站购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前，我们的授权合作伙伴包括以下三大类型： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A.供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;B.第三方商家。我们必须将您的订单信息与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;C.广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。但我们可能会将使用您的信息而形成的用户画像与提供广告、分析服务的合作伙伴共享，以帮助在不识别您个人的前提下提升广告及服务信息的有效触达率。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）转让 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）公开披露 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们仅会在以下情况下，公开披露您的个人信息： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、获得您明确同意后； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;六、我们如何保护您的个人信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;七、您的权利 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、查询和更正您的个人信息 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除法律法规规定外，您有权在登陆本平台后查询您的个人信息。
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、在以下情形中，您可以向我们提出删除个人信息的请求： 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）如果我们处理个人信息的行为违反法律法规； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）如果我们收集、使用您的个人信息，却未征得您的同意； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）如果我们处理个人信息的行为违反了与您的约定； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）如果您不再使用我们的产品或服务，或您注销了账号； 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）如果我们不再为您提供产品或服务。 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;八、本政策如何更新 
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会以通告的形式发布对本政策所做的任何变更，在该种情况下，界面上会有弹框进行提示，若您点击同意后，即表示接受修订后的隐私政策约束。 

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九、争议解决
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;因本指引以及我们处理您个人信息事宜引起的任何争议，您可诉至【上海市普陀区】人民法院。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关政府部门进行反映。
         </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="blacklistDialog dialog" title="个人信息采集授权" :visible.sync="authorizeDialog7"
    width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">个人信息采集授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
<span style="white-space: pre-line;padding: 0 5px;">
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了加强个人信息校验，提供更完善的服务包括推荐任务、紧急联系等，您将授权米咖收集、使用、保存您的个人信息，包括：身高、学历、住址、紧急联系人
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在进行个人信息采集的过程中，所执行的操作均视为您同意米咖的个人信息采集方式并予以授权执行。如在此过程中，您不同意或者对采集方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。
</span>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="人脸识别服务授权" :visible.sync="authorizeDialog8"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">人脸识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
<span style="white-space: pre-line;padding: 0 5px;">
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，您授权米咖收集、使用、保存您通过您的设备终端提供的人脸识别信息。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括与法律法规允许或政府机关授权的机构所保存的信息，或在本人提供的各人脸信息之间进行比对核验。）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的人脸识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 我们努力在现有技术能力基础之上保障人脸识别服务正常运行，并将尽力来提升人脸识别验证的准确性。但是，由于采集人脸信息容易受到表情、妆容、环境光等多种不特定因素影响，而且能收集的信息范围相对有限，技术水平和认证手段也在不断升级改进之中，我们无法保证每次人脸识别均能验证成功。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在进行人脸识别的过程中，所执行的操作均视为您同意米咖的人脸识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。
</span>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="身份信息识别服务授权" :visible.sync="authorizeDialog9"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">身份信息识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
<span style="white-space: pre-line;padding: 0 5px;">
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为加强个人信息校验，保障您的账号权益，您将授权米咖采集、使用、保存您的姓名、身份证号、身份证有效期、身份证照片进行身份识别。&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的身份信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在进行身份信息识别的过程中，所执行的操作均视为您同意米咖的身份信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。
</span>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="银行信息识别服务授权" :visible.sync="authorizeDialog10"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">银行信息识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
<span style="white-space: pre-line;padding: 0 5px;">
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为确保您的服务费结算真实有效，您将授权米咖收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在进行银行信息识别的过程中，所执行的操作均视为您同意米咖的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。
</span>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="地理信息采集授权" :visible.sync="authorizeDialog11"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">地理信息采集授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
<span style="white-space: pre-line;padding: 0 5px;">
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为确保您的服务费结算真实有效，您将授权米咖收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：米咖有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向米咖反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您在进行银行信息识别的过程中，所执行的操作均视为您同意米咖的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，米咖对您的操作信息不予保存。
</span>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="隐私政策" :visible.sync="authorizeDialog12"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">隐私政策</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
        <p style="white-space: pre-line; padding: 0 5px">
          发布时间：2022年【6】月【29】日</p>
        <p style="white-space: pre-line; padding: 0 5px">
          更新时间：2024年【4】月【29】日</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;相关定义：</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、【米咖】服务提供者：指【米咖】的互联网信息及软件技术服务提供者【普乐师（上海）数字科技有限公司】（注册地址：【上海市嘉定区马陆镇嘉昌路288号1幢A区104室】）、上海若胜米咖信息技术有限公司（注册地址：【上海市嘉定区马陆镇周赵路570弄8号1幢】）及关联公司。
          </p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  2、关联公司：指现在、将来控制【普乐师（上海）数字科技有限公司】、受【普乐师（上海）数字科技有限公司】控制或与【普乐师（上海）数字科技有限公司】处于共同控制下的公司、机构，包括不限于【上海赢迪营销服务有限公司、上海赢迪市场营销服务有限公司、上海明酷营销服务有限公司、上海明酷商务咨询有限公司、上海翰为市场营销策划有限公司、上海呈智信息科技有限公司、北京若胜科技有限公司、北京普乐师科技有限公司】。 </p>
          <br>
          <p class="alertContainer"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、控制：指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。</p>
          <br>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  米咖为【米咖】服务提供者（下称“我们”）运营的“米咖”微信公众号（下称“本平台”）。我们非常重视用户（下称“您“）的个人信息保护，并会尽全力保护您的个人信息安全可靠。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本《隐私政策》（下称“本政策”）适用于本平台所提供的服务，请您在使用本平台服务前，仔细阅读并理解本政策，特别是以粗体标识的条款，并在确认充分理解并同意后再开始使用本平台服务；如您不同意本政策中的任何条款，您应立即停止访问或使用本平台服务。当您使用或继续使用本平台服务时，即表示您已充分阅读、理解并接受本政策的全部内容。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如我们提供的某款服务有单独的隐私信息授权或相应的用户服务协议当中存在隐私授权，则该服务的隐私服务授权将优先适用，该款服务隐私授权未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了我们提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于【普乐师(上海)数字科技有限公司】和/或其关联公司已另行独立设置隐私政策的产品及/或服务。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如对本政策有任何疑问、意见和建议，您可以通过本政策中提供的联系方式与我们联系。</p>
          <br>
          <p class="alertContainer">摘要</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本《隐私政策摘要》（“本摘要”）适用于【普乐师(上海)数字科技有限公司】、上海若胜米咖信息技术有限公司及关联公司（下称“我们”）运营的“米咖”微信公众号（本摘要中称“平台”），我们希望通过本摘要向您简要说明我们如何收集、使用、共享、保护您的个人信息，以及您管理个人信息的方式。更多详细信息请查阅完整版的《隐私政策》 。
          </p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.收集的个人信息</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台会为实现【日常任务管理、任务推荐、任务结算、信息查询】等基本功能及其他扩展功能收集和使用您的个人信息。您可点此查看  个人信息收集清单。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.与第三方共享的个人信息</p>
          <br>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在法定情形之外，平台会与关联公司及合作伙伴共享您的个人信息（包括以SDK形式），您可点此查看我们 与第三方共享个人信息清单。 </p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.您如何管理您的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以访问、更正、删除您的个人信息，您还可以撤回同意、注销账号、获取您的个人信息副本、向指定的第三方转移个人信息，以及行使其他个人信息主体的法定权利</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4.平台如何保存您的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们只会在达成本政策所述目的所必要的期限内保留您的个人信息，除非法律有强制的留存要求；我们在中华人民共和国境内运营过程中收集和产生的您的个人信息将存储于境内。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.平台如何处理未成年人的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6．与我们联系</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  我们设立了个人信息专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【service@plscn.com】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路652号6号楼2楼】。您还可以随时拨打我们的客服电话【021-60321998】与我们联系；一般情况下，我们将在15个工作日内回复。</p>
          <br>
          <p class="alertContainer">如您想了解更加详尽的信息，请根据本隐私政策目录阅读相应内容：</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、我们如何收集和使用您的个人信息
          </p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 二、我们如何共享、委托处理、转让、公开披露您的个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  三、我们如何保存和保护您的个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、您如何管理您的个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、我们如何处理未成年人的个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;六、本政策如何更新</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;七、如何联系我们</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 一、我们如何收集和使用您的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）我们收集和使用您的个人信息的场景</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 为更好地为您提供服务，我们将遵循“合法、正当、必要”原则，按照法律法规的规定或您的同意收集您的个人信息，包括以下场景：</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）注册</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 为了您注册使用我们的产品，我们需要收集您的姓名、手机号。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务。</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）身份认证、实名认证、银行卡认证</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，我们需要收集您的个人自拍照、个人自拍视频；为加强个人信息校验，保障您的账号权益，我们需要收集您的姓名、身份证号、身份证有效期、身份证照片；为确保您的服务费结算真实有效，我们需要收集您的持卡人姓名、持卡人身份证号、银行卡号、开户行、银行卡照片。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在认证的过程中，可能需要由提供认证服务的第三方认证机构核验你的真实身份信息。这些信息仅供完成认证的目的，或其他法律法规所规定的用途，未经您明示授权不会用作其他目的。若您拒绝提供相关个人信息进行认证，将可能无法使用必须认证才可使用的功能或相关服务，但不影响您浏览任务广场。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）完善信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了加强个人信息校验，提供更完善的服务包括推荐任务、紧急联系等，我们可能需要收集您的身高、学历、住址、紧急联系人姓名、紧急联系人手机号。 若您拒绝提供相关个人信息，将可能无法使用相关功能或服务，但不影响您浏览任务广场。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）任务广场</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了向您展示您所在城市的任务，我们需要收集您的位置信息，您可选择通过系统授权我们收集获取，或由您自主选择您所在的城市。若您拒绝提供地理位置信息，将可能无法使用相关功能或服务。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）开始任务、任务数据提报</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在您领取任务后，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作，我们需要收集您的以下信息：个人自拍视频、位置信息。在您提供前述个人信息后，才可以开始任务。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在任务中进行中，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作并且确保您提报的任务数据的真实性，我们需要收集您的以下信息：个人形象照片、证件照、个人自拍视频、位置信息。您若不提供前述个人信息，则无法完成任务。</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）第三方收集和使用信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1）第三方服务收集信息的情形

            在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务。这些SDK可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）从第三方获得您的个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）我们收集和使用个人信息的其他规则</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、我们会根据本政策的约定，在实现我们的产品/服务功能所必要的范围内，对所收集的个人信息进行使用。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  2、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1）为履行法定义务或法定职责所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（5）依法在合理的范围内处理您自行公开或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（6）法律、行政法规规定的其他情形。</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行匿名化地研究、统计分析和预测，用于改善我们的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），此类处理后数据的使用无需另行向您通知并征得您的同意。
          </p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、我们如何共享、委托处理、转让、公开披露您的个人信息</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（一）共享</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们不会与您在本平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、与我们合作中的品牌客户公司共享：在你为品牌客户提供任务服务期间，为履行您作为一方当事人的合同所必需，您同意平台将您的信息，包括不限于您的姓名、身份证件号码、身份证照片、银行卡信息、银行卡照片、个人自拍照片、个人自拍视频、电话号码、必要的位置信息，披露给合作中的促销活动品牌方，并允许品牌方使用。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、与我们的关联公司共享：为实现我们的产品或服务的功能或提供您需要的服务，保护您的账号与交易安全，或为维护我们及我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害而有必要的情形下，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。您可点此查看我们与 第三方共享个人信息清单。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（二）委托处理</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 我们可能委托授权合作伙伴处理您的个人信息，以便向您提供相应的产品或服务。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品或服务所必要的个人信息。如果我们的合作伙伴将您的个人信息用于我们未委托的用途，其将单独征得您的同意。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的合作伙伴包括：提供技术服务的供应商。我们可能会将您的个人信息提供给支持我们功能的第三方，包括为我们提供基础设施技术服务、数据分析服务及数据处理服务等的供应商。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对我们委托合作伙伴处理个人信息的，我们会与其签署数据保护协议，要求其按照协议约定、本隐私政策以及相关法律法规要求来处理个人信息。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（三）转让</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、在涉及重组、合并、收购、破产清算、资产转让等情形时，如涉及到个人信息转让，我们会向您告知新的持有您个人信息的公司、组织的名称或者姓名和联系方式，并要求该公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（四）公开披露</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 我们仅会在以下情况下，公开披露您的个人信息：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、获得您明确同意后；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（五）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  1、与我们履行法律法规规定的义务相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、与国家安全、国防安全直接相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6、您自行向社会公众公开的个人信息；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 8、法律法规规定的其他情形。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、我们如何保存和保护您的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、信息存储的地点</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，如需向境外提供，我们将遵照个人信息出境的相关法律规定处理。</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、信息存储的期限</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们承诺，只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年、《中华人民共和国网络安全法》要求相关的网络日志的保存时间不少于六个月。超出保存期限的用户信息，本平台会做删除或匿名化处理；</p>
          <span>当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式或其他形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</span>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、我们保护您个人信息的技术与措施</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （1）我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权的访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解您设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知您。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）我们会严格按照《网络安全法》、《数据安全法》、《个人信息保护法》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、您如何管理您的个人信息</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、查询、更正和补充您的个人信息</p>
          <p class="">除法律法规规定外，您有权在登陆本平台后查询、更正和补充您的个人信息</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、在以下情形中，您可以通过本政策提供的联系方式向我们提出删除个人信息的请求：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）如果我们处理个人信息的行为违反法律法规；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）如果我们处理个人信息的行为违反了与您的约定；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）如果您不再使用我们的产品或服务，或您注销了账号；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （5）如果我们不再为您提供产品或服务。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、注销您的个人账号</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以通过以下方式申请注销您的个人账号：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）在【个人中心】提交账号注销申请；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）通过拨打客服热线【021-60321998】进行注销。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们会在接收到您提出的注销申请后15个工作日内完成您的注销申请并将你的个人信息匿名化处理</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、改变您授权同意的范围或撤回您的授权</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以通过管理设备权限等方式改变或者撤回您授权我们收集和处理您的个人信息的范围。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、向指定的第三方转移个人信息</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您如果需要将您的个人信息转移至您指定的第三方的，您可以通过本政策载明的方式联系我们，在符合法律法规规定的条件下，我们将逐一处理和响应</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6、获取您的个人信息副本</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 如您需要获取我们收集的您的个人信息副本，您可通过本政策载明的方式联系我们，我们会对您进行个人信息校验。完成个人信息主体确认后，我们会在符合相关法律规定且技术可行的前提下，根据您的要求将个人信息副本通过您提供的联系方式或其他方式提交给您</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7、响应您的请求</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）如果您无法通过上述方式管理您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过我们在本政策中提供的联系方式联系我们。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）为了保障安全，我们可能需要您提供书面请求，或以其它方式证明您的身份，我们将在收到您反馈并验证您的身份后的15个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;·与我们履行法律法规规定的义务相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  ·与国家安全、国防安全直接相关的；

            ·与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;·有充分证据表明您存在主观恶意或滥用权利的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  ·响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·涉及商业秘密的。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;五、我们如何处理未成年人的个人信息</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 六、本政策如何更新</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本平台上发出更新版本并在生效前以适当方式提醒您相关内容的更新，也请您及时了解最新的隐私政策。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本政策所指的重大变更包括但不限于：</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、本平台的业务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、个人信息共享或公开披露的主要对象发生变化；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、用户个人信息权利及其行使方式发生重大变化；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6、个人信息保护影响评估报告表明存在有高风险时。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 七、如何联系我们</p>
          <br>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们设立了个人信息保护专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【service@plscn.com】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路652号6号楼2楼】。您还可以随时拨打我们的客服电话【021-60321998】与我们联系。 需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题</p>
          <p class="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  一般情况下，我们将在15个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向本政策签订地上海市普陀区有管辖权的法院提起诉讼。</p>
          <br>
</div>
</div>
</el-dialog>
<el-dialog class="blacklistDialog dialog" title="免责规范及自我声明" :visible.sync="authorizeDialog13"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">免责规范及自我声明</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
        <!-- <p style="white-space: pre-line; padding: 0 5px">
          发布时间：2022年【6】月【29】日</p>
          <br> -->
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    为合法合规承揽业务、提供服务，本人特此声明和承诺如下：</p>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。
          </p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   二、本人声明和承诺承揽业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。 </p>
          <br>
          <p class="alertContainer"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。</p>
          <br>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争s行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。</p>
          <br>
          <p class="alertContainer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。</p>
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="DP免责规范及自我声明V2" :visible.sync="authorizeDialog14"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">DP免责规范及自我声明V2</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
        <!-- <p style="white-space: pre-line; padding: 0 5px">
          发布时间：2022年【6】月【29】日</p>
          <br> -->
          <p style="text-indent: 2em;">为合法合规承揽业务、提供服务，本人特此声明和承诺如下：</p>
          <p style="text-indent: 2em;">一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。
          </p>
          <br>
          <p style="text-indent: 2em;">二、1）本人声明和承诺如承揽宝洁店内短促任务业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。</p>
          <br>
          <p style="text-indent: 2em;">2）本人声明和承诺如承揽宝洁HPP业务、提供服务期间，不得同时承接其他促销任务（包括宝洁店内短促任务和其他公司促销活动等）。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。</p>

          <br>
          <p style="text-indent: 2em;">三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。</p>
          <br>
          <p style="text-indent: 2em;">四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。</p>
          <br>
          <p style="text-indent: 2em;">五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。</p>
          <br>
          <p style="text-indent: 2em;">以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。</p>
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="RS免责规范及自我声明" :visible.sync="authorizeDialog15"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">RS免责规范及自我声明</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
        <!-- <p style="white-space: pre-line; padding: 0 5px">
          发布时间：2022年【6】月【29】日</p>
          <br> -->
          <p style="text-indent: 2em;">为合法合规承揽业务、提供服务，本人特此声明和承诺如下：</p>
          <p style="text-indent: 2em;">一、本人声明承揽业务、提供服务期间，与品牌方、业务发布方、平台方、服务门店不存在劳动关系或劳务派遣关系。
          </p>
          <br>
          <p style="text-indent: 2em;">二、1）本人声明和承诺如承揽宝洁店内短促任务业务、提供服务期间，并未为且不会为与品牌方存在竞争关系的第三方（联合利华、上海家化、汉高、欧莱雅、霸王、金佰利、花王、立白）提供任何服务，坚决杜绝利益冲突行为。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。 </p>
          <br>
          <p style="text-indent: 2em;">2）本人声明和承诺如承揽宝洁HPP业务、提供服务期间，不得同时承接其他促销任务（包括宝洁店内短促任务和其他公司促销活动等）。本人一旦违反前述确认和承诺，导致品牌方、业务发布方、平台方和服务门店涉及民事索赔、行政处罚、刑事犯罪等，由此产生的一切不利后果（如损害赔偿、诉讼费用[诉讼费、律师费、担保费、鉴定费、评估费、公证费、调查取证费]等），概由本人全部承担。</p>

          <br>
          <p style="text-indent: 2em;">三、本人承诺承揽业务、提供服务期间，为提高品牌知名度和美誉度，同意严格遵守品牌方和服务门店制定的各项工作守则及工作纪律。本人清楚知悉，此为品牌方和服务门店为确保服务质量所必要监督，不视为品牌方和服务门店对本人进行劳动用工管理。</p>
          <br>
          <p style="text-indent: 2em;">四、本人承诺承揽业务、提供服务期间，严格遵守法律法规有关禁止商业贿赂行为、不正当竞争行为规定，坚决拒绝商业贿赂（行贿、索贿、受贿）、不正当竞争及其他不正当利益。</p>
          <br>
          <p style="text-indent: 2em;"> 五、本人承诺承揽业务、提供服务期间，严格履行保密义务，对因承揽业务、提供服务过程中所知悉的相关资料、业务数据、业务需求以及其他文件和信息予以保密。此保密义务不因服务终止而终止。</p>
          <br>
          <p style="text-indent: 2em;">以上声明和承诺是本人真实意思表示，本人自愿接受声明和承诺的约束。本声明线上签署，与线下签署具有同等法律效力。</p>
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="个人视频共享授权" :visible.sync="authorizeDialog16"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">个人视频共享授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
          <p style="text-indent: 2em;">为了加强个人信息校验，保障您的权益，您将授权我们向品牌方共享您的刷脸视频，如您不同意共享此信息，则可能影响任务的执行。</p>
          
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="小程序-隐私政策" :visible.sync="authorizeDialog18"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">小程序-隐私政策</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
         <div id="thirdPartyInfo">
<p class="p" align="center" style="text-align:center;">
	<b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;"><span>隐私政策</span></span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;"><span>-小程序版</span></span></b><b><span style="font-family:Calibri;font-weight:bold;font-size:12.0000pt;"></span></b>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>相关定义：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1<span>、【</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>FMES</span><span>米享家</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>】服务提供者：指【</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>FMES</span><span>米享家</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>】</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>的互联网信息及软件技术服务提供者【普乐师（上海）数字科技有限公司】（注册地址：【上海市嘉定区马陆镇嘉昌路</span>288<span>号</span><span>1</span><span>幢</span><span>A</span><span>区</span><span>104</span><span>室】）、上海若胜</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>米咖</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>信息技术有限公司（注册地址：【上海市嘉定区马陆镇周赵路</span>570<span>弄</span><span>8</span><span>号</span><span>1</span><span>幢】）及关联公司。 </span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p" style="margin-left:26.0000pt;text-indent:0.0000pt;">
	<span style="font-family:Calibri;font-size:12.0000pt;"><span>2、</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>关联公司：指现在、将来控制【普乐师（上海）数字科技有限公司】、受【普乐师（上海）数字科技有限公司】控制或与【普乐师（上海）数字科技有限公司】处于共同控制下的公司、机构，包括不限于【上海赢迪营销服务有限公司、上海赢迪市场营销服务有限公司、上海明酷营销服务有限公司、上海明酷商务咨询有限公司、上海翰为市场营销策划有限公司、上海呈智信息科技有限公司、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>若胜市场营销策划（上海）有限公司、上海若胜米咖信息技术有限公司、上海加诺普科技有限公司、</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>北京若胜科技有限公司、北京普乐师科技有限公司】。</span> </span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3<span>、控制：指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理</span><span>/</span><span>经营的能力。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="16" style="font-family:宋体;font-size:12.0000pt;"><span>普乐师（上海）数字科技有限公司</span></span><span class="16" style="font-family:Calibri;font-size:12.0000pt;"><span>（下称</span><span>“</span><span>我们</span><span>”</span><span>）运营的</span><span>“</span></span><span class="16" style="font-family:宋体;font-size:12.0000pt;"><span>FMES</span><span>米享家</span></span><span class="16" style="font-family:Calibri;font-size:12.0000pt;"><span>”</span></span><span class="16" style="font-family:宋体;font-size:12.0000pt;"><span>小程序</span></span><span class="16" style="font-family:Calibri;font-size:12.0000pt;"><span>（下称</span><span>“</span><span>本平台</span><span>”</span><span>）非常重视用户（下称</span><span>“</span><span>您</span><span>“</span><span>）的个人信息保护，并会尽全力保护您的个人信息安全可靠。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>本《隐私政策》（下称</span><span>“</span><span>本政策</span><span>”</span><span>）适用于本平台所提供的服务，请您在使用本平台服务前，仔细阅读并理解本政策，特别是以粗体标识的条款，并在确认充分理解并同意后再开始使用本平台服务；如您不同意本政策中的任何条款，您应立即停止访问或使用本平台服务。当您使用或继续使用本平台服务时，即表示您已充分阅读、理解并接受本政策的全部内容。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>如我们提供的某款服务有单独的隐私信息授权或相应的用户服务协议当中存在隐私授权，则该服务的隐私服务授权将优先适用，该款服务隐私授权未涵盖的内容，以本政策内容为准。如我们关联公司的产品或服务中使用了我们提供的产品或服务但未设置独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于【普乐师</span><span>(</span><span>上海</span><span>)</span><span>数字科技有限公司】和</span><span>/</span><span>或其关联公司已另行独立设置隐私政策的产品及</span><span>/</span><span>或服务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>如对本政策有任何疑问、意见和建议，您可以通过本政策中提供的联系方式与我们联系。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;"><span>摘要</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>本《隐私政策摘要》（</span><span>“</span><span>本摘要</span><span>”</span><span>）适用于【普乐师</span><span>(</span><span>上海</span><span>)</span><span>数字科技有限公司】、上海若胜</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>米咖</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>信息技术有限公司及关联公司（下称</span><span>“</span><span>我们</span><span>”</span><span>）运营的</span><span>“</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>FMES</span><span>米享家</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>”</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>小程序</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>（本摘要中称</span><span>“</span><span>平台</span><span>”</span><span>），</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>我们希望通过本摘要向您简要说明我们如何收集、使用、共享、保护您的个人信息，以及您管理个人信息的方式。更多详细信息请查阅完整版的《隐私政策》</span> <span>。</span> </span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.<span>收集的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>平台会为实现【任务</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>查询</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>、任务推荐、任务结算</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>】等基本功能及其他扩展功能收集和使用您的个人信息。您可点此查看</span> <span>个人信息收集清单。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.<span>与第三方共享的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>在法定情形之外，平台会与关联公司及合作伙伴共享您的个人信息（包括以</span><span>SDK</span><span>形式），您可点此查看我们 与<span style="color: blue; cursor: pointer;" onclick="document.getElementById('thirdPartyInfoPopup').style.display='';document.getElementById('thirdPartyInfo').style.display='none'">第三方共享个人信息清单</span>。 </span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.<span>您如何管理您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>您可以访问、更正、删除您的个人信息，您还可以撤回同意、注销账号、获取您的个人信息副本、向指定的第三方转移个人信息，以及行使其他个人信息主体的法定权利</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4.<span>平台如何保存您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们只会在达成本政策所述目的所必要的期限内保留您的个人信息，除非法律有强制的留存要求；我们在中华人民共和国境内运营过程中收集和产生的您的个人信息将存储于境内。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.<span>平台如何处理未成年人的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6<span>．与我们联系</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>我们设立了个人信息专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【</span><span>service@plscn.com</span><span>】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路</span><span>652</span><span>号</span><span>6</span><span>号楼</span><span>2</span><span>楼】。您还可以随时拨打我们的客服电话【</span><span>021-60321998</span><span>】与我们联系；一般情况下，我们将在</span><span>15</span><span>个工作日内回复。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;"><span>如您想了解更加详尽的信息，请根据本隐私政策目录阅读相应内容：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>一、我们如何收集和使用您的个人信息 </span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>二、我们如何共享、委托处理、转让、公开披露您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>三、我们如何保存和保护您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>四、您如何管理您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>五、我们如何处理未成年人的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>六、本政策如何更新</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>七、如何联系我们</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>一、我们如何收集和使用您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（一）我们收集和使用您的个人信息的场景</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>为更好地为您提供服务，我们将遵循</span><span>“</span><span>合法、正当、必要</span><span>”</span><span>原则，按照法律法规的规定或您的同意收集您的个人信息，包括以下场景：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>1</span><span>）注册</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>为了您注册使用我们的产品，我们需要收集您的姓名、手机号。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）身份认证、实名认证、银行卡认证</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，我们需要收集您的个人自拍照、个人自拍视频；为加强个人信息校验，保障您的账号权益，我们需要收集您的姓名、身份证号、身份证有效期、身份证照片；为确保您的服务费结算真实有效，我们需要收集您的持卡人姓名、持卡人身份证号、银行卡号、开户行、银行卡照片。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>在认证的过程中，可能需要由提供认证服务的第三方认证机构核验你的真实身份信息。这些信息仅供完成认证的目的，或其他法律法规所规定的用途，未经您明示授权不会用作其他目的。若您拒绝提供相关个人信息进行认证，将可能无法使用必须认证才可使用的功能或相关服务，但不影响您浏览任务广场。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>3</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>）任务广场</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>为了向您展示您所在城市的任务，我们需要收集您的位置信息，您可选择通过系统授权我们收集获取，或由您自主选择您所在的城市。若您拒绝提供地理位置信息，将可能无法使用相关功能或服务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>4</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>）开始任务、任务数据提报</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>在您领取任务后，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作，我们需要收集您的以下信息：个人自拍视频、位置信息。在您提供前述个人信息后，才可以开始任务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>在任务中进行中，为了加强个人信息校验，保障你的权益，确保是您本人进行账号的操作并且确保您提报的任务数据的真实性，我们需要收集您的以下信息：个人形象照片、证件照、个人自拍视频、位置信息。您若不提供前述个人信息，则无法完成任务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（二）第三方收集和使用信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>）第三方服务收集信息的情形 在某些特定业务场景下，为了提高业务处理能力、提升响应速度或其他方面考虑，我们可能会使用有能力的第三方服务商提供的软件服务工具包（简称</span><span>SDK</span><span>）来为您提供服务。这些</span><span>SDK</span><span>可能会收集和使用您的个人信息，我们会在您授权同意后收集和使用。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）从第三方获得您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（三）我们收集和使用个人信息的其他规则</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>、我们会根据本政策的约定，在实现我们的产品</span><span>/</span><span>服务功能所必要的范围内，对所收集的个人信息进行使用。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2<span>、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3<span>、您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>）为履行法定义务或法定职责所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>3</span><span>）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>4</span><span>）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>5</span><span>）依法在合理的范围内处理您自行公开或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>6</span><span>）法律、行政法规规定的其他情形。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行匿名化地研究、统计分析和预测，用于改善我们的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），此类处理后数据的使用无需另行向您通知并征得您的同意。 </span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>二、我们如何共享、委托处理、转让、公开披露您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（一）共享</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们不会与您在本平台服务客户以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2<span>、与我们合作中的品牌客户公司共享：在你为品牌客户提供任务服务期间，为履行您作为一方当事人的合同所必需，您同意平台将您的信息，包括不限于您的姓名、身份证件号码、身份证照片、银行卡信息、银行卡照片、个人自拍照片、个人自拍视频、电话号码、必要的位置信息，披露给合作中的促销活动品牌方，并允许品牌方使用。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3<span>、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4<span>、与我们的关联公司共享：为实现我们的产品或服务的功能或提供您需要的服务，保护您的账号与交易安全，或为维护我们及我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害而有必要的情形下，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5<span>、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。您可点此查看我们与 第三方共享个人信息清单。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（二）委托处理</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>我们可能委托授权合作伙伴处理您的个人信息，以便向您提供相应的产品或服务。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供产品或服务所必要的个人信息。如果我们的合作伙伴将您的个人信息用于我们未委托的用途，其将单独征得您的同意。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们的合作伙伴包括：提供技术服务的供应商。我们可能会将您的个人信息提供给支持我们功能的第三方，包括为我们提供基础设施技术服务、数据分析服务及数据处理服务等的供应商。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>对我们委托合作伙伴处理个人信息的，我们会与其签署数据保护协议，要求其按照协议约定、本隐私政策以及相关法律法规要求来处理个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（三）转让</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1<span>、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2<span>、在涉及重组、合并、收购、破产清算、资产转让等情形时，如涉及到个人信息转让，我们会向您告知新的持有您个人信息的公司、组织的名称或者姓名和联系方式，并要求该公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（四）公开披露</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>我们仅会在以下情况下，公开披露您的个人信息：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>、获得您明确同意后；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2<span>、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（五）共享、转让、公开披露个人信息时事先征得授权同意的例外</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1<span>、与我们履行法律法规规定的义务相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2<span>、与国家安全、国防安全直接相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3<span>、与公共安全、公共卫生、重大公共利益直接相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4<span>、与犯罪侦查、起诉、审判和判决执行等直接相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5<span>、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6<span>、您自行向社会公众公开的个人信息；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7<span>、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 8<span>、法律法规规定的其他情形。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>三、我们如何保存和保护您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>、信息存储的地点</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，如需向境外提供，我们将遵照个人信息出境的相关法律规定处理。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2<span>、信息存储的期限</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们承诺，只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年、《中华人民共和国网络安全法》要求相关的网络日志的保存时间不少于六个月。超出保存期限的用户信息，本平台会做删除或匿名化处理；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>当我们的产品或服务发生停止服务的情形时，我们将以推送通知、公告形式或其他形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</span> </span><span style="font-family:Calibri;font-size:10.5000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3<span>、我们保护您个人信息的技术与措施</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>（</span><span>1</span><span>）我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权的访问或披露。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的个人信息泄露。为了预防病毒、木马程序或其他恶意程序、我们会了解您设备安装的应用信息或正在运行的进程信息。我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。若发生个人信息泄露安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告形式告知您。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）我们会严格按照《网络安全法》、《数据安全法》、《个人信息保护法》等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>3</span><span>）请您理解：互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性，在用户登录时采用身份鉴权模式；数据传输时采用报文加密的方式；每个用户通过会话保证确保访问控制正常。但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>四、您如何管理您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1<span>、查询、更正和补充您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;"><span>除法律法规规定外，您有权在登陆本平台后查询、更正和补充您的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2<span>、在以下情形中，您可以通过本政策提供的联系方式向我们提出删除个人信息的请求：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>1</span><span>）如果我们处理个人信息的行为违反法律法规；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）如果我们收集、使用您的个人信息，却未征得您的同意；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>3</span><span>）如果我们处理个人信息的行为违反了与您的约定；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>4</span><span>）如果您不再使用我们的产品或服务，或您注销了账号；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>（</span><span>5</span><span>）如果我们不再为您提供产品或服务。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3<span>、注销您的个人账号</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>您可以通过以下方式申请注销您的个人账号：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>1</span><span>）在【</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>我的</span></span><span style="font-family:Calibri;font-size:12.0000pt;"><span>】提交账号注销申请；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）通过拨打客服热线【</span><span>021-60321998</span><span>】进行注销。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们会在接收到您提出的注销申请后</span><span>15</span><span>个工作日内完成您的注销申请并将你的个人信息匿名化处理</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4<span>、改变您授权同意的范围或撤回您的授权</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>您可以通过管理设备权限等方式改变或者撤回您授权我们收集和处理您的个人信息的范围。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5<span>、向指定的第三方转移个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>您如果需要将您的个人信息转移至您指定的第三方的，您可以通过本政策载明的方式联系我们，在符合法律法规规定的条件下，我们将逐一处理和响应</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6<span>、获取您的个人信息副本</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>如您需要获取我们收集的您的个人信息副本，您可通过本政策载明的方式联系我们，我们会对您进行个人信息校验。完成个人信息主体确认后，我们会在符合相关法律规定且技术可行的前提下，根据您的要求将个人信息副本通过您提供的联系方式或其他方式提交给您</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7<span>、响应您的请求</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>1</span><span>）如果您无法通过上述方式管理您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过我们在本政策中提供的联系方式联系我们。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>2</span><span>）为了保障安全，我们可能需要您提供书面请求，或以其它方式证明您的身份，我们将在收到您反馈并验证您的身份后的</span><span>15</span><span>个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>（</span><span>3</span><span>）在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;·<span>与我们履行法律法规规定的义务相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·<span>与国家安全、国防安全直接相关的； </span><span>·</span><span>与公共安全、公共卫生、重大公共利益直接相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·<span>与犯罪侦查、起诉、审判和执行判决等直接相关的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;·<span>有充分证据表明您存在主观恶意或滥用权利的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·<span>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ·<span>涉及商业秘密的。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>五、我们如何处理未成年人的个人信息</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们的服务主要面向成人，我们不会主动直接向未成年人收集其个人信息。如果有事实证明未成年人在未取得监护人同意的情况下注册使用了我们的服务，我们会设法尽快删除相关个人信息。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>六、本政策如何更新</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本平台上发出更新版本并在生效前以适当方式提醒您相关内容的更新，也请您及时了解最新的隐私政策。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>本政策所指的重大变更包括但不限于：</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1<span>、本平台的业务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2<span>、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3<span>、个人信息共享或公开披露的主要对象发生变化；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4<span>、用户个人信息权利及其行使方式发生重大变化；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5<span>、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6<span>、个人信息保护影响评估报告表明存在有高风险时。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>七、如何联系我们</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-align:left;">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>我们设立了个人信息保护专职部门，如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，您可以通过邮箱【</span><span>service@plscn.com</span><span>】与其联系，或寄送信件至如下地址：【上海市普陀区长寿路</span><span>652</span><span>号</span><span>6</span><span>号楼</span><span>2</span><span>楼】。您还可以随时拨打我们的客服电话【</span><span>021-60321998</span><span>】与我们联系。 需注意的是，我们可能不会回复与本政策或您的个人信息权利无关的问题</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="p">
	<span style="font-family:Calibri;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span>一般情况下，我们将在</span><span>15</span><span>个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向本政策签订地上海市普陀区有管辖权的法院提起诉讼。</span></span><span style="font-family:Calibri;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal">
	<span style="font-family:Calibri;font-size:10.5000pt;">&nbsp;</span>
</p>
</div>
<!-- 新增弹窗 div -->
<div id="thirdPartyInfoPopup" style="display: none;">
    <div style="text-align: right;">
        <button onclick="document.getElementById('thirdPartyInfoPopup').style.display='none';document.getElementById('thirdPartyInfo').style.display=''">返回</button>
    </div>
    
	<p>
	&nbsp;米咖接入第三方SDK清单
	<table border="0" cellpadding="0" cellspacing="0" width="1559" height="770" style="border-collapse:collapse;width:779.52pt;" class="ke-zeroborder">
		<tbody>
			<tr>
				<td class="et3" height="28" width="108">
					<br />
				</td>
				<td class="et3" width="249">
					<br />
				</td>
				<td class="et3" width="157">
					<br />
				</td>
				<td class="et3" width="178">
					<br />
				</td>
				<td class="et3" width="108">
					<br />
				</td>
				<td class="et3" width="223">
					<br />
				</td>
				<td class="et3" width="108">
					<br />
				</td>
				<td class="et3" width="202">
					<br />
				</td>
				<td class="et3" width="223">
					<br />
				</td>
			</tr>
			<tr>
				<td colspan="9" class="et6" height="34">
					第三方SDK列表
				</td>
			</tr>
			<tr>
				<td class="et8" height="56" width="108">
					序号
				</td>
				<td class="et8" width="249">
					<span class="font0">第三方</span><span class="font3">SDK</span>
				</td>
				<td class="et8" width="157">
					第三方公司名称
				</td>
				<td class="et8" width="178">
					使用目的
				</td>
				<td class="et8" width="108">
					使用场景
				</td>
				<td class="et8" width="223">
					个人信息收集类型
				</td>
				<td class="et8" width="108">
					申请的权限
				</td>
				<td class="et8" width="202">
					收集方式
				</td>
				<td class="et8" width="223">
					第三方隐私政策链接
				</td>
			</tr>
			<tr>
				<td class="et9" height="148" width="108">
					1
				</td>
				<td class="et10" width="249">
					微信公众号SDK
				</td>
				<td class="et10" width="157">
					深圳市腾讯计算机系统有限公司
				</td>
				<td class="et10" width="178">
					用户业务入口
				</td>
				<td class="et10" width="108">
					用户登入米咖时
				</td>
				<td class="et10" width="223">
					GPS定位
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK本机采集，不涉及数据共享
				</td>
				<td class="et12" width="223">
					<a href="https://mp.weixin.qq.com/">https://mp.weixin.qq.com/</a>
				</td>
			</tr>
			<tr>
				<td class="et9" height="84" width="108">
					2
				</td>
				<td class="et10" width="249">
					腾讯人脸核身
				</td>
				<td class="et10" width="157">
					深圳市腾讯计算机系统有限公司
				</td>
				<td class="et10" width="178">
					用户身份校验
				</td>
				<td class="et10" width="108">
					执行任务刷脸时
				</td>
				<td class="et10" width="223">
					头像照、上半身视频、身份证号、姓名
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK本机采集，SDK传输
				</td>
				<td class="et13" width="223">
					<a href="https://cloud.tencent.com/document/product/1007/71390">https://cloud.tencent.com/document/product/1007/71390</a>
				</td>
			</tr>
			<tr>
				<td class="et9" height="140" width="108">
					3
				</td>
				<td class="et10" width="249">
					百度地图
				</td>
				<td class="et10" width="157">
					北京百度网讯科技有限公司
				</td>
				<td class="et10" width="178">
					用于GPS定位和IP定位，如推荐附件任务、采集上报任务时的定位
				</td>
				<td class="et10" width="108">
					用户查看附近任务时；用户上报任务时
				</td>
				<td class="et10" width="223">
					GPS、ssid、bssid
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK传输
				</td>
				<td class="et12" width="223">
					<a href="https://lbsyun.baidu.com/index.php?title=openprivacy">https://lbsyun.baidu.com/index.php?title=openprivacy</a>
				</td>
			</tr>
			<tr>
				<td class="et9" height="112" width="108">
					5
				</td>
				<td class="et10" width="249">
					OCR识别
				</td>
				<td class="et10" width="157">
					北京百度网讯科技有限公司
				</td>
				<td class="et10" width="178">
					识别身份证和银行卡信息
				</td>
				<td class="et10" width="108">
					用户实名认证时，用户银行卡认证时
				</td>
				<td class="et10" width="223">
					身份证照片、姓名、身份证号、身份证有效期、银行卡照片、银行卡号
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK传输
				</td>
				<td class="et12" width="223">
					<a href="https://cloud.baidu.com/campaign/OCR202203/index.html">https://cloud.baidu.com/campaign/OCR202203/index.html</a>
				</td>
			</tr>
			<tr>
				<td class="et9" height="112" width="108">
					6
				</td>
				<td class="et10" width="249">
					人脸核身
				</td>
				<td class="et10" width="157">
					深圳市腾讯计算机系统有限公司
				</td>
				<td class="et10" width="178">
					用户身份校验
				</td>
				<td class="et10" width="108">
					用户身份认证时；用户实名认证时
				</td>
				<td class="et10" width="223">
					上半身照片、自拍小视频、姓名、身份证号
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK传输
				</td>
				<td class="et12" width="223">
					<a href="https://cloud.tencent.com/document/product/1007/71390">https://cloud.tencent.com/document/product/1007/71390</a>
				</td>
			</tr>
			<tr>
				<td class="et9" height="56" width="108">
					7
				</td>
				<td class="et10" width="249">
					银行卡三、四要素验证
				</td>
				<td class="et10" width="157">
					上海加数信息科技有限公司
				</td>
				<td class="et10" width="178">
					银行卡认证、服务费结算
				</td>
				<td class="et10" width="108">
					用户银行卡认证时
				</td>
				<td class="et10" width="223">
					姓名、身份证号、银行卡号
				</td>
				<td class="et10" width="108">
					<br />
				</td>
				<td class="et10" width="202">
					SDK传输
				</td>
				<td class="et10" width="223">
					<br />
				</td>
			</tr>
		</tbody>
	</table>
	</p>
	<p>
		<br />
	</p>
	<p>
		<br />
	</p>
	<p>
		米咖与其他第三方共享个人信息清单
	</p>
	<table border="0" cellpadding="0" cellspacing="0" width="1335" height="1957" style="border-collapse:collapse;width:667.52pt;" class="ke-zeroborder">
		<tbody>
			<tr>
				<td class="et3" height="28" width="108">
					<br />
				</td>
				<td class="et3" width="249">
					<br />
				</td>
				<td class="et3" width="157">
					<br />
				</td>
				<td class="et3" width="178">
					<br />
				</td>
				<td class="et3" width="108">
					<br />
				</td>
				<td class="et3" width="223">
					<br />
				</td>
				<td class="et3" width="108">
					<br />
				</td>
				<td class="et3" width="202">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et5" height="60" width="108">
					序号
				</td>
				<td class="et5" width="249">
					第三方公司名称
				</td>
				<td class="et5" width="157">
					产品/类型
				</td>
				<td class="et5" width="178">
					共享个人信息类型
				</td>
				<td class="et5" width="108">
					使用目的
				</td>
				<td class="et5" width="223">
					使用场景
				</td>
				<td class="et5" width="108">
					共享方式
				</td>
				<td class="et5" width="202">
					第三方隐私政策链接
				</td>
			</tr>
			<tr>
				<td class="et6" height="56" width="108">
					1
				</td>
				<td class="et7" width="249">
					支付宝（杭州）信息技术有限公司
				</td>
				<td class="et7" width="157">
					开户行查询
				</td>
				<td class="et7" width="178">
					银行卡号
				</td>
				<td class="et7" width="108">
					查询开户行信息
				</td>
				<td class="et7" width="223">
					用户银行卡认证时
				</td>
				<td class="et7" width="108">
					api
				</td>
				<td class="et7" width="202">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="140" width="108">
					2
				</td>
				<td class="et8" width="249">
					江西薪太软科技发展有限公司
				</td>
				<td class="et8" width="157">
					灵工任务签约
				</td>
				<td class="et8" width="178">
					姓名、身份证号码、手机号码
				</td>
				<td class="et8" width="108">
					领取第三方发布的灵工任务并进行签约
				</td>
				<td class="et8" width="223">
					用户领取灵工任务时，执行灵工任务时
				</td>
				<td class="et8" width="108">
					api
				</td>
				<td class="et8" width="202">
					斜杠管家小程序
				</td>
			</tr>
			<tr>
				<td class="et6" height="142" width="108">
					3
				</td>
				<td class="et8" width="249">
					上海明酷市场营销服务有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et11">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="133" width="108">
					4
				</td>
				<td class="et8" width="249">
					上海翰为市场营销策划有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="145" width="108">
					5
				</td>
				<td class="et8" width="249">
					上海赢迪市场营销服务有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="136" width="108">
					6
				</td>
				<td class="et8" width="249">
					上海明酷营销服务有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="120" width="108">
					7
				</td>
				<td class="et8" width="249">
					上海明酷商务咨询有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="121" width="108">
					8
				</td>
				<td class="et8" width="249">
					上海赢迪营销服务有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="154" width="108">
					9
				</td>
				<td class="et8" width="249">
					若胜市场营销策划（上海）有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="126" width="108">
					10
				</td>
				<td class="et8" width="249">
					上海呈智信息科技有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="148" width="108">
					11
				</td>
				<td class="et8" width="249">
					上海若胜米咖信息技术有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="148" width="108">
					12
				</td>
				<td class="et8" width="249">
					上海加诺普科技有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="148" width="108">
					13
				</td>
				<td class="et8" width="249">
					北京普乐师科技有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
			<tr>
				<td class="et6" height="148" width="108">
					14
				</td>
				<td class="et8" width="249">
					北京若胜科技有限公司
				</td>
				<td class="et10">
					互联网/api
				</td>
				<td class="et10">
					<br />
				</td>
				<td class="et10">
					数据共享
				</td>
				<td class="et10">
					全场景
				</td>
				<td class="et10">
					api
				</td>
				<td class="et10">
					<br />
				</td>
			</tr>
		</tbody>
	</table>
	<br />
</div>
          
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="小程序-服务协议" :visible.sync="authorizeDialog19"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">小程序-服务协议</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
         <h3 align="center" style="text-align:center;">
	<b><span style="font-family:宋体;font-weight:bold;font-size:13.5000pt;"><span>平台用户服务协议</span></span></b><b><span style="font-family:宋体;font-weight:bold;font-size:13.5000pt;"></span></b>
</h3>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;">&nbsp;</span>
</p>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;">&nbsp;</span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>欢迎您使用</span></span><span class="15" style="font-family:宋体;font-size:10.5000pt;"><span>F</span></span><span class="15" style="font-family:宋体;font-size:10.5000pt;"><span>ME</span></span><span class="15" style="font-family:宋体;font-size:10.5000pt;"><span>S</span></span><span class="15" style="font-family:宋体;font-size:10.5000pt;"><span>米享家</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>向您提供的各项服务！以下简称</span><span>“平台” &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>您在使用本平台所提供的服务前，应当仔细认真阅读本《平台用户服务协议》</span>(以下简称“本协议”)中的全部规则、及平台不时发布或更新的其他服务条款、专项产品或服务规则</span><span style="font-family:宋体;font-size:12.0000pt;"><span>（</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>以下合称</span><span>“服务规则”）的内容（特别是其中以黑体字标示出的关于平台及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议 解决条款，请您重点阅读），确认对本条款、《平台用户服务协议》 及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。如您使用平台或以其他方式使用或接受平台的任何服务，即视为您已阅读并与平台达成协议，自愿接受本条款的所有内容的约束。所有服务规则视为本条款不可分割的一部分，与本条款具有同等法律效力。 本条款的签约双方为本平台的实际开发商上海若胜米咖信息技术有限公司及集团公司与使用平台服务的您（下称“您”），本条款是您与本平台之间关于您使用平台入驻服务商之间发布的任务服务所订立的服务条款， 具有正式书面合同的效力。 如本条款与《平台用户服务协议》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本协议为准。本协议有待明确、存在歧义或未规定之处均以《平台用户服务协议》中的规定为准。 您理解并同意，平台将根据本条款及《平台用户服务协议》的规定及商业因素，对本协议条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《平台用户服务协议》的相关约定。变更后的协议和规则一经在平台公布后，立即自动生效。如您不同意相关变更，应当立即停止使用平台服务。您继续使用平台服务的，即表示您接受经修订的协议和规则。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>一、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>定义</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="margin-left:0.0000pt;text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>1.1<span>&nbsp;</span></span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>平台任务：</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>指平台入驻方（以下简称第三方）提出的任务发布服务，并通过该平台展示</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>平台任务</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>任务</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>服务费</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>即</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>任务</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>确认</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>等信息的互联网技术平台。</span> &nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="margin-left:0.0000pt;text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>1.2<span>&nbsp;</span></span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>信息服务：平台利用电脑、服务器、互联网、电话、移动设备等信息</span></span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>通讯设备，向您展示订单，促成您与需求方达成服务合作。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="margin-left:0.0000pt;text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>1.3<span>&nbsp;</span></span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>任务订单：登记第三方具体需求信息任务的电子订单。您按照平台的要求提供的抢单、签约、激活订单等信息，全部信息作为一个整体构成一个订单。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>二、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>账号注册与使用</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;">2.1 您知悉并同意</span><span style="font-family:宋体;font-size:12.0000pt;"><span>：</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>为使用</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>第三方服务，</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>您可</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>注册</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>新账号</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>或</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>登录</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>现有</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>账号，</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>同时</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>须</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>遵守</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>《</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>平台</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>用户服务</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>协议</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>》</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>的</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>规定</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>。</span></span><span style="font-family:宋体;font-size:12.0000pt;">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2.2 您确认，在您完成注册程序或以其他平台允许的方式实际使用平台服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且平台有权注销或永久冻结您的账号，并保留向您及您的监护人索偿的权利。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2.3 您承诺向平台所提供的信息真实、准确、完整。平台有权要求您提供各项信息文件，并验证其真实性，当查验您提供的信息可能缺乏真实性、准确性时，平台有权进一步要求您提供其他证明文件或拒绝向您提供服务或拒绝您使用有关网站、服务、应用程序。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2.4 您应是您注册账号的唯一授权使用人，可根据自己的需求使用，但不得以任何形式将账号转让或出借他人使用。未经平台授权同意，您也不得将账号相关的权利义务转让给他人。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2.5 鉴于网络服务的特殊性，除您第三方使用平台服务时外，平台无义务审核是否是用户本人使用该账号，仅审核用户身份识别信息是否与数据库中保存的一致，所以即使用户认为账号登录行为并非用户本人所为，平台将不承担因此而产生的任何责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>三、服务规范</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.1 您在使用平台服务时，除了应当遵循诚实信用原则，遵守法律法规、所在服务单位的政策以及规章制度外，还应当遵守本协议</span><span style="font-family:宋体;font-size:12.0000pt;"><span>的各项规定。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.2 平台根据您的服务状态向您提供第三方任务、订单信息等，您可自主选择是否处于服务状态。如您接受订单，您应按照订单需求为第三方提供服务，并遵守本条款约定的平台规则。您可通过下载并安装到移动设备上的平台提供的应用程序或其他方式选择并使用平台信息服务。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.3 本平台的运营权归普乐师（上海）数字科技有限公司所有。平台向您提供的是信息服务，而非通讯服务，您在使用平台提供的服务时，应具备可以安装平台相关应用程序的终端设备。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.4 您与平台合作为第三方提供服务的时间为订单成立且您准备提供服务的时间。在非合作期间，平台并不要求您继续为第三方提供服务。如因其他原因需要继续服务，则该服务行为属于您的个人行为与本平台无关。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.5 您注册和使用本平台过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等您所发送、回复或自动回复消息和相关链接页面，以及其他使用用户账号或本平台产生的内容均不得违反现行法律、法规、规章、政策规定；如果您在境外使用本平台，应同时遵守所在地或相关国家（地区）的法律法规。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6 您不得利用本平台制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.1 反对宪法所确定的基本原则的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.3 损害国家荣誉和利益的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.4 煽动民族仇恨、民族歧视，破坏民族团结的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.5 破坏国家宗教政策，宣扬邪教和封建迷信的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.6 散布谣言，扰乱社会秩序，破坏社会稳定的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.8 侮辱或者诽谤他人，侵害他人合法权益的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.6.9 含有法律、行政法规禁止的其他内容的信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7 您不得利用本平台制作、上载、复制、发布、传播如下干扰平台正常运营，以及侵犯其他用户或第三方合法权益的内容： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.1 含有任何性或性暗示的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.2 含有辱骂、恐吓、威胁内容的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.3 含有骚扰、垃圾广告、恶意信息、诱骗信息的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.4 涉及他人隐私、个人信息或资料的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.5 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.7.6 含有其他干扰本平台正常运营和侵犯其他用户或第三方合法权益内容的信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8 您不得利用本平台进行如下行为： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.1 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.2 虚构事实、隐瞒真相以误导、欺骗他人的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.3 利用技术手段批量建立虚假账号的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.4 利用本平台从事任何违法犯罪活动的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.5 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的； &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.8.6 其他违反法律法规规定、侵犯其他用户合法权益、干扰本平台正常运营或本平台未明示授权的行为。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.9 承诺与保证 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.9.1 除遵守本条款、《平台用户服务协议》及服务规则外，您应进一步保证您符合从事社会服务的相关标准，包括但不限于您满足服务地城市、相关法律法规规定的户籍或居住证等有关要求，无限制从业的相关疾病，并符合以下条件： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.9.1.1 年龄：18-60周岁；普通话标准；无犯罪记录、无吸毒记录、无精神病史，未列入公安部门不良记录。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.9.1.2身体健康，外露皮肤无明显疤痕、纹身，无怪异发型(颜色），无传染性疾病；无下列可能影响服务的疾病：器质性心脏病；癫痫病；美尼尔氏症；眩晕症；癔病；震颤麻痹；精神病；痴呆以及影响肢体活动的神经系统疾病；妨碍安全服务疾病及传染性疾病（如：肺结核、腮腺炎等通过空气、飞沫传播的传染病）;长期服用依赖性精神药品成瘾尚未戒除的。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.9.2 如您未满足以上标准或要求，平台有权立即终止与您的合作。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.10 您在浏览、访问或使用平台产品及服务时可能以各种形式获取、知悉与平台或第三方有关的秘密信息（包括但不限于第三方信息、平台及其关联公司的运营或财务信息等）。为更好地保护您、第三方及我们的合法权益，您将严格遵守保密义务，不会在任何时间以任何方式窃取、泄露前述秘密信息。如果您发生本条款禁止行为，我们将会采取相应措施，包括但不限于中止或终止向您提供任何产品或服务、要求您承担损害赔偿责任；如果您的行为构成犯罪，将被追究相应的刑事责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.11 费用支付 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.11.1 平台有权制定相关费用结算标准并</span><span style="font-family:宋体;font-size:12.0000pt;"><span>实时</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>更新予以公示</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>，具体订单结算适用订单发生时</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>按照任务详情结算标准</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.11.2 如您使用第三方支付系统从服务单位处收取结算的费用，应由您自行开通第三方支付系统服务（包括但不限于</span><span style="font-family:宋体;font-size:12.0000pt;"><span>银行卡</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>微信支付、支付宝等）。您在使用第三方支付时，除了受到本条款的约束之外，还要受电子支付服务商</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>及信用卡</span>/借记卡发卡行的条款和政策的约束。平台不为第三方提供的服务承担责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.11.3 您可以随时通过平台查询订单情况，您应在每次服务完成后及时核对订单信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3.12 您在平台中或通过平台所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本平台的观点、立场；您不得以平台的名义传送或发布信息；也不得以易被公众或第三方混淆为平台官方意见的方式传送或发布信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>四、风险承担</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">4.1 您在使用平台的过程中，将会涉及到第三方提供的地图及导航等服务，请您务必在确保安全的前提下使用上述服务，以防发生其他危险情况。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">4.2 平台向您提供信息技术服务，对于您给第三方提供的服务过程中产生的风险不承担责任，但法律法规另有强制性规定的除外。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">4.3 平台与您合作向第三方提供的服务，双方关系受《中华人民共和国民法典》等民事法律的约束。平台与您之间不构成任何直接或间接的劳动关系，不适用 《劳动法》《劳动合同法》《社会保险法》《住房公积金管理条例》等法律法规。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>五、对您信息的管理及限制</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">5.1 您知悉、理解并同意，在您使用平台时，您同意平台依据《平台隐私政策》的规定执行相关个人信息的收集、使用和共享。平台亦有权应政府部门（包括司法及行政部门）的要求，向其提供您的相关信息。此外，您知悉并认可：平台可能会与第三方合作而向您提供相关的功能，在此情况下，如该第三方同意承担与平台同等的保护您隐私的责任，则平台有权将您的相关资料等提供给该第三方。另外，在不透露您隐私资料的前提下，平台有权对与您账号相关的整个数据库进行分析并对相关的数据库进行商业上的利用。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">5.2 您被平台终止服务或账号被注销后，平台没有义务为您保留或向您披露账号中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">5.3 您同意，平台停止向您提供服务后，平台仍享有下列权利： &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">5.3.1 继续保存您未及时删除的信息及使用平台期间发布的所有信息至法律规定的记录保存期满。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">5.3.2 您在使用期间存在违法行为或违反本条款和/或服务规则的行为的，平台仍可依据本条款向您主张权利。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>六、知识产权</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">6.1 平台所展示的各运营系统由本平台自主开发、运营提供技术支持，并对平台服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。平台提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归平台所有。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">6.2 您理解并同意：您在使用平台过程中所产生、上传的内容等所有信息的知识产权及所有权，适用《平台用户服务协议》中的相关约定。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;七、责任限制声明 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.1 您确认，您在使用平台为平台第三方所提供的服务时，应当具备中华人民共和国法律规定的完全民事权利能力和民事行为能力。否则您及您的监护人应依照法律规定承担因此而导致的一切后果，在该等情形下，平台有权立即注销您的账号或停止向您提供服务，您应就由此给平台造成的所有损失予以赔偿。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.2 您应谨慎合理的保存、使用用户名和密码，并对通过您的账号和密码实施 的所有行为、活动及事件负全责。您若发现任何不当使用账号或存在安全漏洞等其他可能危及您账号安全的情况，应立即依照《平台用户服务协议》的相关规定采取措施并予以处理。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.3 由于您的过错给平台第三方或其他第三方造成侵权损害，应当由您承担相应的赔偿责任，对于由于您的过错造成的侵权损害或您因违约给平台造成的损失，平台有权向您追偿。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.4 如您在使用平台的过程中发现平台中的相关服务信息违反法律规定，您可及时向平台或有关机关举报或投诉，平台将在收到您的举报或投诉时采取相应的核实与处理措施。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.5 平台在为您提供服务时，可能会引入平台范围之外的第三方服务商提供的服务（第三方签约服务、支付服务、查询服务等）。您知悉、理解并同意，您使用平台号访问或使用第三方服务商提供的服务时将跳转至第三方服务商的独立平台。第三方服务商并非本平台，亦不通过本平台向您提供任何服务或达成任何交易。因此，本平台无法实质审核、控制第三方服务商及其所提供的具体服务或对第三方服务予以任何形式的担保或承诺。您应在访问或使 用第三方服务商的服务前应自行核实第三方服务商的身份、资质、服务内容等 相关信息，仔细约定第三方服务商的相关服务协议或规则，并自行选择是否进行本条款下的授权操作并使用本平台账号接受相关第三方服务商服务，本平台将不就您所接受的第三方服务商服务向您承担任何责任。您拟接受的第三方服务商服务将由该第三方服务商独立运营并独立承担全部责任。因该第三方服务所产生的纠纷，或第三方服务商违反相关法律法规或本条款约定，或您在使用第三方服务过程中遭受的损失，请您根据与第三方服务商所订立的相关服务协议等相应协议或规则，联系第三方服务商予以解决。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.6 对于来源于外部的风险，比如违法犯罪活动、交通事故等意外事件等造成的损失，由相关责任方承担，本平台将会积极协助相关部门进行处理。对于您在提供平台服务过程中发生的不可抗力事件，本平台将会在合理范围内进行协助解决。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.7 您同意并确认，本平台拥有独自决定拒绝向您提供服务的权利。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.8 您同意本平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知信息的权利。此外，您允许本平台依照《平台用户服务协议》及《平台隐私政策》的相关规定向您发送商业性电子信息或广告促销信息。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.9 您不得在本平台上发布不良违法信息以及与本平台提供服务无关的信息、或发布《平台用户服务协议》中规定的其他禁止用户发布的信息或从事其他违反《平台用户服务协议》规定的行为，否则本平台有权随时永久停止向您提供服务，由此产生的一切责任应由您自行承担。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">7.10 不论在何种情况下,本平台对由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>八、通知的发送</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">8.1 您同意本条款项下本平台对于您所有的通知（包括商品信息或商业性广告）均可通过网页公告、客户端推送消息、发送到用户注册的电子邮件、手机或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人，以上通知模式均具有同样的法律效力。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">8.2 您对于本平台的通知应当通过本平台对外正式公布的通信地址、传真 号码、电子邮件地址等联系信息进行送达。该等通知以本平台实际收到日为送达日。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>九、条款的终止</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">9.1 本平台有权终止向您提供服务，本条款于全部服务依法定程序及方式终止之日终止。 </span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">9.2 本条款的终止不影响本平台其他主体依据本条款享有的各项权利的实现，也不影响守约方向违约方追究违约责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>十、争议解决</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">10.1 如您与本平台第三方服务发生任何争议，平台可在法律法规要求的范围内协助您与平台第三方之间争议的协商调解。您同意，本平台有权通过电话或电子邮件等方式向争议双方了解情况，并将所了解的情况通过必要方式通知对方。此外，您有权通过司法或执法机关要求本平台提供相关资料，但您理解并同意，本平台无任何义务对您与服务单位之间的任何争议承担任何责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">10.2 若您与平台因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向平台主体公司所在地上海市普陀区人民法院提起诉讼。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">10.3 因您使用本平台服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。您在使用我公司应用程序并通过该应用程序接单或服务平台第三方，即视为您已充分理解并与平台服务商之间签署的服务条款。并在此前提下同意接受本条款中约定的平台规则及违规责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>一、如您存在下列违反平台规则的行为，应当按照本条款约定承担违规责任。违规责任包括违约金、暂停服务或解除合作。在您接到投诉的情况下，平台有权进行调查，调查期间将暂停对您的平台服务。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>二、您在使用本平台服务时，不得有下列破坏平台规则，损害平台第三方、其他平台用户及平台利益的作弊行为。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">1 利用虚假的账号，以获取奖励、订单、好评等为目的的作弊行为 （如：伪造账号接单、团伙刷单、模拟刷单、自己或串通他人伪造第三方账号以骗取平台奖励等）。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2 安装使用对平台产生干扰的设备或第三方作弊软件的行为。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3 短时间内完成多个订单且订单金额不在正常交易范围内的订单/订单金额异常。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">4 其他作弊违规行为。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>三、</span></span><span style="font-family:宋体;font-size:12.0000pt;"><span>违反平台规则，应当承担以下违约责任。</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="margin-left:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">1 平台判定您在服务过程中存在不规范操作行为（如：接单后不执行、爽约</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>、违约等）的，</span> <span>平台有权立即暂停该账号接单</span> 24小时；不规范行为同时违反本条款第一条的，平台也有权按照第一条的规定，要求您承担违规责任。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:Calibri;font-size:10.5000pt;"></span>
</p>
<p class="MsoNormal" style="margin-left:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">2 违反本条款第二条规定的，平台有权暂停该账号一切活动，包括关于该</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>账号的费用结算。同一账号第一次被判定为作弊的，平台有权暂停该账号接单</span>3天，第二次被判定为作弊的，平台有权暂停该账号接单7天；第三次及以上被判定为作弊的，平台有权暂停该账号接单30天。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;">3 平台有权不结算作弊订单或收回已结算作弊订单的金额，并收取相当于作弊订单金额三倍的违约金。 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family:宋体;font-size:12.0000pt;"></span>
</p>
<p class="MsoNormal" style="text-indent:21.0000pt;">
	<span style="font-family:宋体;font-size:12.0000pt;"><span>四、您理解并同意，因您违反本协议约定或发生其它过错，导致或产生的任何第三方向平台或其合作方、关联方主张任何索赔、要求，如果造成平台或其合作方、关联方发生的任何损失，包括合理的律师费，您应当向平台与合作方、关联方承担赔偿责任。平台可以协助合作方、关联方向您主张权利。</span></span><span style="font-family:Calibri;font-size:10.5000pt;"></span>
</p>
          
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="小程序-人脸识别服务授权" :visible.sync="authorizeDialog20"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">小程序-人脸识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
         <p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">人脸识别服务授权</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp;&nbsp; 为加强个人信息校验、确保是您本人进行账号的操作、保障您的账号权益，您授权立白PLUS+收集、使用、保存您通过您的设备终端提供的人脸识别信息。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp;&nbsp; 我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括与法律法规允许或政府机关授权的机构所保存的信息，或在本人提供的各人脸信息之间进行比对核验。）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的人脸识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 我们努力在现有技术能力基础之上保障人脸识别服务正常运行，并将尽力来提升人脸识别验证的准确性。但是，由于采集人脸信息容易受到表情、妆容、环境光等多种不特定因素影响，而且能收集的信息范围相对有限，技术水平和认证手段也在不断升级改进之中，我们无法保证每次人脸识别均能验证成功。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 您在进行人脸识别的过程中，所执行的操作均视为您同意立白PLUS+的人脸识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。</p><p><br/></p>
          
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="小程序-身份信息识别服务授权" :visible.sync="authorizeDialog21"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">小程序-身份信息识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
  <p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">身份信息识别服务授权</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 为加强个人信息校验，保障您的账号权益，您将授权立白PLUS+采集、使用、保存您的姓名、身份证号、身份证有效期、身份证照片进行身份识别。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp;&nbsp; 我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的身份信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 您在进行身份信息识别的过程中，所执行的操作均视为您同意立白PLUS+的身份信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。</p><p><br/></p>
          
</div>
</div>
</el-dialog>

<el-dialog class="blacklistDialog dialog" title="小程序-银行信息识别服务授权" :visible.sync="authorizeDialog22"
width="1030px" center>
<div style="font-size: 15px;padding: 10px;text-align: left;">
<div style="">
<h3 style="text-align: center;margin-bottom: 5px;font-weight: 700">小程序-银行信息识别服务授权</h3>
</div>
<div style="overflow-y: scroll;max-height: 400px;">
  <p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">银行信息识别服务授权</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp;&nbsp; 为确保您的服务费结算真实有效，您将授权立白PLUS+收集、使用、保存您的银行卡信息，包含：持卡人姓名、银行卡号、开户行，银行卡照片。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp;&nbsp; 我们将遵循“合法、正当、必要”原则并严格遵守《隐私政策》，按照法律法规的规定和您的同意使用您的个人信息。您已知悉并同意我们对以上信息使用范围包括：立白PLUS+有权委托第三方授权合作伙伴处理您的个人信息，第三方授权合作伙伴有权获取您的前述信息进行核查（包括通过合法存有您信息的机构进行核查）、验证、比对识别并向立白PLUS+反馈、输出验证结果，以便完成您的银行信息识别，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp; &nbsp; 我们将采取必要措施保障您的信息安全，防止您的信息被非法泄露或不当使用。</p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;"><br/></p><p style="margin-top: 0px; margin-bottom: 0px; text-rendering: optimizelegibility; font-feature-settings: &quot;kern&quot;; font-kerning: normal;">&nbsp;&nbsp; &nbsp;&nbsp; 您在进行银行信息识别的过程中，所执行的操作均视为您同意立白PLUS+的银行信息识别方式并予以授权执行。如在此过程中，您不同意或者对识别方式有任何疑问，请立即停止操作，立白PLUS+对您的操作信息不予保存。</p><p><br/></p>
          
</div>
</div>
</el-dialog>
  <LogOut ref="LogOut"/>
  </div>
</template>

<script>
  import idcardDefaultCover from 'common/images/idCard-img.png'
  import idcardDefaultBack from 'common/images/idCard-img2.png'
  import bankcardDefaultCover from 'common/images/bankCard-img.png'
  import idCardBack_demo from 'common/images/idCardBack-demo.png'
  import idCardCover_demo from 'common/images/idCardCover-demo.png'
  import headImg_demo from 'common/images/headImg-demo.png'

  import FilterTab from 'components/filterTab'
  import SalespersonInfo from 'components/salespersonInfo'
  import rule from '../../common/js/formRules'
  import utils from '../../common/js/util.js'
  import VDistpicker from 'v-distpicker'
  import LogOut from '@/views/personnelCenter/baseCenter/LogOut.vue'
  export default {
    components: {
      FilterTab,
      SalespersonInfo,
      VDistpicker,
      LogOut
    },
    data() {
      return {
        pageNo: 1,
        pageSize: 10,
        total: null,
        formData: {
          name: null,
          idcard: null,
          provinceId: null,
          cityId: null,
          areaId: null,
          sex: null,
          educationId: null,
          status: null,
          starLevelId: null,
          agreement: null,
          channel: null,
          ageMin: null,
          ageMax: null,
          heightMin: null,
          heightMax: null,
          creditScoreMin: null,
          creditScoreMax: null,
          projectNumMin: null,
          projectNumMax: null,
          workMonthMin: null,
          workMonthMax: null,
          frequencyNumMin: null,
          frequencyNumMax: null,
          projectPriceMin: null,
          projectPriceMax: null,
          postId: 0,
          pageNo: 1,
          pageSize: 10,
          authorizeFlag: null
        },

        tableData: [],
        idList: [],
        idArr:[],
        resultList:[],
        reasonList: [],
        projectDropDownList:[],//所属项目选择
        projectDropDownListKeep:[],//存储所属项目选择
        unbindDialog:false,//注册解绑界面
        resetDialog:false,//认证重置界面
        blacklistDialog: false,
        greylistDialog:false,
        idCardDialog: false,
        bankCardDialog: false,
        personInfoDialog: false,
        approveDialog: false,//人工认证弹窗
        idCardCover_demo: idCardCover_demo,//人工认证弹窗中三张默认照片
        idCardBack_demo: idCardBack_demo,
        headImg_demo: headImg_demo,
        isUploading: '',//当前即将被校验的头像类型
        approveData: {//人工认证相关信息
          lockApproveDialog: false,//人工认证窗口的loading，防上传照片连续点击
          approvingID: '',//正在被人工认证的人的id
          newName: "",//新的姓名
          newIdcard: null,//新的身份证号
          lockIdCard: false,//上传图片后锁定身份证号字段，图片存储时命名需要，不然每张图都用不同的身份证号就乱套了
          headImg: '',//头像地址，仅用于成功后显示
          idCardCoverImg: '',//身份证正面地址，仅用于成功后显示
          idCardBackImg: '',//身份证背面地址，仅用于成功后显示
          headImgUpName: {name: ''},//上传时头像的文件名字
          idCardCoverUpName: {name: ''},//上传时身份证正面的文件名字
          idCardBackUpName: {name: ''},//上传时身份证背面的文件名字
          lockConfirm: false,//上传过程中防连续点击，锁定确认按钮的可用状态
          empPk: "", // 促销员ID
          idcardValidStart:"",
          idcardValidEnd:"",
          applicant:"",//申请人
          applyReason:"",//申请原因
          projectCode:"",//所属项目 实际是projectCode&orgName 提交时剪掉
          orgName:"",//所属部门
          id:""
        },
        rules: {//人工认证中的校验
          newIdcard: [rule.idcard],
          applicant:[rule.applicant]
        },
        reason: '',
        listLoading: false,

        SalespersonId: '',
        idcardCoverImg: '',
        idcardBackImg: '',
        bankCoverImg: '',
        idcardNum: '',
        bank: '',
        bankNum: '',

        idcardDefaultCover: idcardDefaultCover,
        idcardDefaultBack: idcardDefaultBack,
        bankcardDefaultCover: bankcardDefaultCover,

        showbigImage: false,
        bigImage: null,
        bigImageWidth: null,
        bigImageHeight: null,
        bigImageWidth2: null,
        type: null,

        // 页面内权限
        auths: [],
        current: 0,
        num: 0,
        isAdmin: false, //是否是超级管理员进入
        operationLogDialog: false, // 操作日志
        operationLogTableData: [], // 操作日志数据
        operationLogFormData: { // 操作日志筛选条件
          pageNo: 1,
          pageSize: 10,
          salesmanName: null,
          idcard: null,
          operationType: "",
          userName: null,
          userAccount: null,
          tel: null,
          empPk: null
        },
        operationTotal: null,
        operationLoading: false,
        bankCardDialogFlag: false,
        bankCardArtificialData: {
          salesmanId: null,
          bank: null, // 开户行
          bankNum: null, // 银行卡号
          salesmanName: null, // 促销员姓名
          bankCover: null, // 银行卡照片
          bankCoverName: {
            name: null // 上传银行卡照片名字
          },
          branch: '', // 开户支行信息
          branchList: null, // 支行列表
          bankAddress: { // 开户行地址
            province: null,
            city: null,
            area: null,
          },
          bankAddressCode: { // 开户行地址编码
            province: null,
            city: null,
            area: null,
          },
          unionPayNo: null, // 联行号
          applicant:"",//申请人
          applyReason:"",//申请原因
          projectCode:"",//所属项目 实际是projectCode&orgName 提交时剪掉
          orgName:"",//所属部门
        },
        // 项目所有客户
        customerList: [],
        // 显示签约合同记录
        showContractDialog: false,
        contractDialogTitle: null,
        contractLoading: false,
        // 签约合同记录筛选条件
        contractFormData: {
          pageNo: 1,
          pageSize: 10,
          startTimeFrom: null,
          startTimeTo: null,
          endTimeFrom: null,
          endTimeTo: null,
          customer: null,
          serviceSupplier: null
        },
        contractTotal: null,
        contractData: null,
        authorizeDialogFlag: false,
        authorizeDialogSalesmanName: "",
        authorizeDialogList: [],
        authorizeDialog1: false,
        authorizeDialog2: false,
        authorizeDialog3: false,
        authorizeDialog4: false,
        authorizeDialog5: false,
        authorizeDialog6: false,
        authorizeDialog7: false,
        authorizeDialog8: false,
        authorizeDialog9: false,
        authorizeDialog10:false,
        authorizeDialog11: false,
        authorizeDialog12: false,
        authorizeDialog13: false,
        authorizeDialog14: false,
        authorizeDialog15: false,
        authorizeDialog16: false,
        authorizeDialog18: false,
        authorizeDialog19: false,
        authorizeDialog20: false,
        authorizeDialog21: false,
        authorizeDialog22: false,
        isAdmin:false,//是否是tinashi或者admin1
      }
    },
    mounted() {
      let user = sessionStorage.getItem('user')
      this.isAdmin = Boolean(user == 'admin1' || user == 'tinashi')
      this.getData()
      this.getAuth()
      this.searchAllCustomer();
      //判断是否是超级管理员
      let x = sessionStorage.getItem('user')
      this.isAdmin = Boolean(x == 'admin1' || x == 'tinashi');
      this.getProjDropDownList();
    },
    methods: {
      formatIdCard(row, column, cellValue) {
        if (this.isAdmin) {
          return cellValue
        } else {
          return utils.plusXing(cellValue, 6, 4)
        }
      },
      formatBankCard(row, column, cellValue) {
        if (this.isAdmin) {
          return cellValue
        } else {
          return utils.plusXing(cellValue, 4, 7)
        }
      },
      formatTel(row, column, cellValue) {
        if (this.isAdmin) {
          return cellValue
        } else {
          return utils.plusXing(cellValue, 3, 4)
        }
      },
      formatTel1(row, column, cellValue) {
        return utils.plusXing(cellValue, 3, 4)
      },
      formatName(row, column, cellValue) {
        let a = cellValue[0]
        if (this.isAdmin) {
          return cellValue
        } else {
          for (let i = 0; i < cellValue.length - 1; i++) {
            a = a + '*'
          }
          return a
        }
      },
      rotate() {
        this.current = (this.current + 90) % 360;
        this.num++

        // document.getElementsByClassName('dialogImage')[0].style.transform = 'rotate('+this.current+'deg)'
        console.log('点旋转图片', document.getElementsByClassName('dialogImage')[0])

        document.getElementsByClassName('dialogImage')[0].parentNode.style.transform = 'rotate(' + this.current + 'deg)'
        // document.getElementsByClassName('dialogImage')[0].parentNode.parentNode.setAttribute("style","width:900px");
        // console.log(document.getElementsByClassName('dialogImage')[0].parentNode)
        // this.bigImageWidth2 = '600px'

      },
      // 图片出错
      setErrorImage(event) {
        switch (this.type) {
          case 1:
            event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultCover})`
            break;
          case 2:
            event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultBack})`
            break;
          case 3:
            event.target.parentNode.style.backgroundImage = `url(${this.bankcardDefaultCover})`
            break;
        }
      },
      // 查看原图
      viewImage(url, type) {
        this.type = type
        this.showbigImage = true
        this.current = 0
        this.num++

        let width;
        let height;
        if (type == 1) {
          if (url == null) {
            this.bigImage = this.idcardDefaultCover
          } else {
            this.bigImage = url
          }
          width = document.getElementsByClassName('floatle')[0].width
          height = document.getElementsByClassName('floatle')[0].height
        } else if (type == 2) {
          if (url == null) {
            this.bigImage = this.idcardDefaultBack
          } else {
            this.bigImage = url
          }
          width = document.getElementsByClassName('floatri')[0].width
          height = document.getElementsByClassName('floatri')[0].height
        } else {
          if (url == null) {
            this.bigImage = this.bankcardDefaultCover
          } else {
            this.bigImage = url
          }
          width = document.getElementsByClassName('bankCardss')[0].width
          height = document.getElementsByClassName('bankCardss')[0].height

        }
        // debugger
        width > 500 ? (width = width / 2 , height = height / 2) : (width, height)
        width < 400 ? (width = 300 , height = 300) : (width, height)
        this.bigImageWidth = width + 'px';
        this.bigImageWidth2 = width + 40 + 'px';
        this.bigImageHeight = height + 'px';
        if (document.getElementsByClassName('dialogImage').length != 0) {
          document.getElementsByClassName('dialogImage')[0].parentNode.style.transform = 'rotate(0deg)'
        }
      },
      avatarBigImg(url) {
        if (url != null) {
          return {
            backgroundImage: 'url(' + url + ')',
            backgroundSize: 'cover',
            // width:this.bigImageWidth,
            // height:this.bigImageHeight
          }
        } else {
          return {
            backgroundImage: 'url(' + this.avatarDefault + ')',
            backgroundSize: 'cover',
            // width:this.bigImageWidth,
            // height:this.bigImageHeight
          }
        }

      },
      handleSizeChange(val) {
        this.formData.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val
        this.getData()
      },
      getParam(data) {
        //这里的pagesize有较大可能会传来48，需要按照本页的要求重置一下
        let size = this.formData.pageSize
        this.formData = Object.assign(this.formData, data)
        this.formData.pageSize = size
        this.formData.pageNo = 1;
        this.getData()
      },
      getData() {
        this.listLoading = true
        this.$http({
          method: "POST",
          url: '/rest/baseCenter/search',
          data: this.formData
        }).then(res => {
          this.listLoading = false
          this.tableData = res.data
          console.log(res.data[0].isLogout);
        }).catch(err => {
          utils.myNotify(this, "error", err.response, '查询失败，请稍后重试')
          this.listLoading = false
        })

        this.$http({
          method: "POST",
          url: '/rest/baseCenter/searchCount',
          data: this.formData
        }).then(res => {
          this.total = res.data
        }).catch(err => {
          utils.myNotify(this, "error", err.response, '查询失败，请稍后重试')
        })
      },
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 2,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          let data = res.data
          data.forEach(item => {
            this.auths.push(item.auth)
          })
          if (this.auths.indexOf(2) >= 0 || this.auths.indexOf(3) >= 0) {
            this.auths.push(1)
          }
        }).catch(err => {
          utils.myNotify(this, "error", err.response, '查询失败，请稍后重试')
        })
      },
      handleSelectionChange(val) {
        this.idList = [];
        this.resultList = []
        val.forEach(item => {
          this.idList.push({id: item.id})
          this.resultList.push(item)
        })
      },
      // 解绑身份证
      batchIdcard() {
        this.unbindDialog = true
        this.clearApproveData();
        this.idList.forEach(item => {
            this.idArr.push(item.id)
          })
      },

      //注册解绑
      unbindIdCardConfirm() {   
        if  (!this.approveData.applicant) {
           utils.myNotify(this, 'warning', '必须填写申请人')
          return false;
        }else if (!this.approveData.applyReason) {
           utils.myNotify(this, 'warning', '必须填写申请原因')
          return false;
        }
        // console.log(this.idArr);
        // return
        this.$http({
            method: 'POST',
            url: '/rest/baseCenter/batchUnbindIdCard',
            data: this.idArr,
            params:{
              applicant: this.approveData.applicant,
              applyReason: this.approveData.applyReason,
              projectCode: this.approveData.projectCode.split('&')[0],
              orgName: this.getOptcode("idcard")
            }
          }).then(res => {
            if (res.data.code == '0' && res.data.status == 200) {
              this.getData()
              utils.myNotify(this, "success", res, '操作成功')
              this.unbindDialog = false;
            } else {
              utils.myNotify(this, "error", res, '操作失败，请稍后重试')
            }
            this.idArr = [];
            this.idList = [];
          }).catch(err => {
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          }); 
      },
      showLogout(){
        this.$refs.LogOut.show()
      },
      // 解绑银行卡
      batchBank() {
        this.$confirm('确认解绑用户银行卡?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let idArr = []
          this.idList.forEach(item => {
            idArr.push(item.id)
          })
          this.$http({
            method: 'POST',
            url: '/rest/baseCenter/batchUnbindBankCard',
            data: idArr
          }).then(res => {
            if (res.data.code == '0' && res.data.status == 200) {
              this.getData()
              utils.myNotify(this, "success", res, '操作成功')
            } else {
              utils.myNotify(this, "error", res, '操作失败，请稍后重试')
            }
          }).catch(err => {
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          })
        }).catch(() => {
        })
      },
      // 更改合约状态
      batchMarkAgreement() {
        this.$confirm('确认更改用户合约状态？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: "POST",
            url: '/rest/baseCenter/batchMarkAgreement',
            data: this.idList
          }).then(res => {
            if (res.data.code == '0' && res.data.status == 200) {
              this.getData()
              utils.myNotify(this, 'success', res, '操作成功')
            } else {
              utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
            }
          }).catch(err => {
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          })
        }).catch(() => {
        })
      },
      //认证状态
      approveReset(id) {
        this.resetDialog = true
        this.clearApproveData();
        this.approveData.id = id
      },
      resetConfirm() {
        if  (!this.approveData.applicant) {
           utils.myNotify(this, 'warning', '必须填写申请人')
          return false;
        }else if (!this.approveData.applyReason) {
           utils.myNotify(this, 'warning', '必须填写申请原因')
          return false;
        } 
        this.$http({
            method: "GET",
            url: '/rest/Register/unbindIdentity',
            params: {
              salesmanId: this.approveData.id,
              applicant: this.approveData.applicant,
              applyReason: this.approveData.applyReason,
              projectCode: this.approveData.projectCode.split('&')[0],
              orgName: this.getOptcode("idcard")
            }
          }).then(res => {
            if (res.data.code == '0' && res.data.status == 200) {
              this.getData()
              utils.myNotify(this, 'success', res, '操作成功')
            } else {
              utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
            }
            this.resetDialog = false;
          }).catch(err => {
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          })
      },
      // 确认拉黑
      batchBlack() {
        this.reasonList = []
        this.idList.forEach(item => {
          this.reasonList.push({
            id: item.id,
            reason: this.reason,
            operatorId: sessionStorage.getItem('sysUserId')
          })
        })
        this.$http({
          method: "POST",
          url: '/rest/baseCenter/batchBlack',
          data: this.reasonList
        }).then(res => {
          this.blacklistDialog = false
          if (res.data.code == '0' && res.data.status == 200) {
            this.getData()
            utils.myNotify(this, 'success', res, '操作成功')
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          this.blacklistDialog = false
        })
      },
      batchGrey() {
        let reasonList = []
        let ids = {};
        this.idList.forEach(item => {
            reasonList.push(item.id)
        })
        ids.salesmanIdLst = reasonList;
        ids.reason = this.reason;
        ids.operatorId = sessionStorage.getItem('sysUserId');
        this.$http({
          method: "POST",
          url: '/rest/baseCenter/batchGrey',
          data: ids
        }).then(res => {
          this.greylistDialog = false;
          if (res.data.code == '0' && res.data.status == 200) {
            this.getData()
            utils.myNotify(this, 'success', res, '操作成功')
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          this.greylistDialog = false
        })
      },
      // 身份证对话框
      showIdCardDialog(row) {
        this.idCardDialog = true
        this.idcardNum = row.idcard
        if (!this.isAdmin) {
          this.idcardNum = utils.plusXing(row.idcard, 6, 4)
         }
        this.idcardCoverImg = row.idcardCover
        this.idcardBackImg = row.idcardBack
      },
      // 银行卡对话框
      showBankCardDialog(row) {
        this.bankCardDialog = true
        this.bankCoverImg = row.bankCover
        this.bank = row.bank
        this.bankNum = row.bankNum
        if (!this.isAdmin) {
           this.bankNum = utils.plusXing(row.bankNum, 4, 7)
       }

      },
      // 查看详情
      viewInfo(id) {
        this.personInfoDialog = true
        this.SalespersonId = id
      },
      //人工认证
      approveByAdmin(row) {
        //先通过后台验证此人是否可以人工认证（好像只有身份认证的可以），可以才继续
        this.$http({
          method: "POST",
          url: '/rest/IdCard/getCrmSalesmanInfo',
          params: {
            salesmanId: row.id,
          }
        }).then(res => {
          this.approveDialog = true;
          this.clearApproveData();
          //先清空再赋值
          this.approveData.approvingID = row.id;
          this.approveData.newName = row.name
          this.approveData.newIdcard = row.idcard
          this.approveData.idcardValidStart = row.idcardValidStart&&''
          this.approveData.idcardValidEnd = row.idcardValidEnd&&''
          this.approveData.applicant = row.applicant
          this.approveData.applyReason = row.applyReason
          this.approveData.projectCode = row.projectCode&&''
          this.approveData.orgName = row.orgName&&''
        }).catch(err => {
          utils.myNotify(this, 'warning', err.response, '查询失败，请稍后重试')
        })
      },
      //人工认证界面确认
      approveConfirm() {
        if (!this.approveData.newName) {
          utils.myNotify(this, 'warning', '必须填写姓名')
          return false;
        }else if (!this.approveData.applicant) {
           utils.myNotify(this, 'warning', '必须填写申请人')
          return false;
        }else if (!this.approveData.applyReason) {
           utils.myNotify(this, 'warning', '必须填写申请原因')
          return false;
        } else if (!this.approveData.idCardCoverImg) {
          utils.myNotify(this, 'warning', '必须上传身份证正面')
          return false;
        }else if (!this.approveData.idCardBackImg) {
          utils.myNotify(this, 'warning', '必须上传身份证背面')
          return false;
        }else if (!this.approveData.idcardValidStart) {
           utils.myNotify(this, 'warning', '请选择身份证有效期开始时间')
          return false;
        }else if (!this.approveData.idcardValidEnd) {
           utils.myNotify(this, 'warning', '请选择身份证有效期结束时间')
          return false;
        }
        let  params = {
          salesmanId: this.approveData.approvingID,
          idCard: String(this.approveData.newIdcard),
          // headImg: this.approveData.headImg,
          idCardCover: this.approveData.idCardCoverImg,
          idcardBack: this.approveData.idCardBackImg,
          name: this.approveData.newName,
          idcardValidStart: this.approveData.idcardValidStart,
          idcardValidEnd: this.approveData.idcardValidEnd,
          applicant: this.approveData.applicant,
          applyReason: this.approveData.applyReason,
          projectCode: this.approveData.projectCode?this.approveData.projectCode.split('&')[0]:'',
          orgName: this.getOptcode("idcard")
        }
        // console.log("---------",params);
        // return
        //请求
        this.approveData.lockConfirm = true;
        console.log(this.approveData.newIdcard)
        this.$http({
          method: "POST",
          url: '/rest/IdCard/artificialCertification',
          params:params
        }).then(res => {
          utils.myNotify(this, 'success', '认证成功！')
          this.approveDialog = false;        
          this.approveData.lockConfirm = false
          this.getData();
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '认证失败')
          this.approveDialog = false;
          this.approveData.lockConfirm = false
        })
      },
      //清空ApproveData数据
      clearApproveData() {
        let x = this.approveData;
        x.approvingID = ''
        x.approvingID = ''
        x.newName = ''
        x.newIdcard = null
        x.lockIdCard = false
        x.headImg = ''
        x.idCardCoverImg = ''
        x.idCardBackImg = ''
        x.headImgUpName.name = ''
        x.idCardCoverUpName.name = ''
        x.idCardBackUpName.name = ''
        x.applicant = ''
        x.applyReason = ''
        x.projectCode = ''
        x.orgName = ''
      },
      //头像上传成功
      headImgUpSucc(res, file) {
        this.approveData.headImg = res.message;
        this.approveData.lockApproveDialog = false;
      },
      //身份证正面上传成功
      idcardCoverUpSucc(res, file) {
        this.approveData.idCardCoverImg = res.message;
        this.approveData.lockApproveDialog = false;
      },
      //身份证反面上传成功
      idCardBackUpSucc(res, file) {
        this.approveData.idCardBackImg = res.message;
        this.approveData.lockApproveDialog = false;
      },
      //图像上传失败通用
      imgUploadErr(err) {
        utils.myNotify(this, 'error', '上传失败，请稍后重试')
        this.approveData.lockApproveDialog = false;
      },
      //图片上传前校验通用方法
      beforeImgUp(file) {
        let isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        let isLt2M = (file.size / 1024 / 1024) < 1;
        let errMsg = ''
        if (!isLt2M) {
          errMsg = '上传的图片大小不能超过 1MB!';
        } else if (!isJPG) {
          errMsg = '请上传jpg、jpeg或png格式的图片';
        }
        if (errMsg != '') {
          utils.myNotify(this, 'warning', errMsg)
          return false;
        } else {
          this.$refs['approveForm'].validate((valid) => {
            //必须先输入正确的身份证号
            if (this.approveData.newIdcard && valid) {
              let x = file.name.split(".")
              this.approveData[this.isUploading + 'UpName'].name =
                this.approveData.newIdcard + (new Date()).getTime() + this.isUploading + '.' + x[x.length - 1]
              this.approveData.lockIdCard = true;
              this.approveData.lockApproveDialog = true;
            } else {
              utils.myNotify(this, 'warning', '请先输入正确的身份证号')
              return false;
            }
          })
        }
      },
      // 身份证正面图片出错
      idcardCoverError(event) {
        // event.target.src = this.idcardDefaultCover
        event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultCover})`
      },
      idcardCoverImgTableError(event) {
        event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultCover})`
      },
      // 身份证背面图片出错
      idcardBackError(event) {
        // event.target.src = this.idcardDefaultBack
        event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultBack})`
      },
      idcardBackTableError(event) {
        event.target.parentNode.style.backgroundImage = `url(${this.idcardDefaultBack})`
      },
      // 银行卡图片出错
      bankCoverError(event) {
        // event.target.src = this.bankcardDefaultCover
        event.target.src = require('common/images/bankCard-img.png')
        // `url(${this.bankcardDefaultCover})`
      },
      //弹框中的银行卡图片出错
      bankCoverError2(event) {
        event.target.parentNode.style.backgroundImage = `url(${this.bankcardDefaultCover})`
      },
      // 表格中显示无压缩图
      noCompression(url, type) {

        if (type == 1) {
          if (url != null) {
            return {
              backgroundImage: 'url(' + url + ')',
              backgroundSize: 'cover',
            }
          } else {
            return {
              backgroundImage: 'url(' + this.idcardDefaultCover + ')',
              backgroundSize: 'cover',
            }
          }
        } else if (type == 2) {
          if (url != null) {
            return {
              backgroundImage: 'url(' + url + ')',
              backgroundSize: 'cover',
            }
          } else {
            return {
              backgroundImage: 'url(' + this.idcardDefaultBack + ')',
              backgroundSize: 'cover',
            }
          }
        } else if (type == 3) {
          if (url != null) {
            return {
              backgroundImage: 'url(' + url + ')',
              backgroundSize: 'cover',
            }
          } else {
            return {
              backgroundImage: 'url(' + this.bankcardDefaultCover + ')',
              backgroundSize: 'cover',
            }
          }
        }

      },
      searchOperationData() {
        this.operationLogFormData.pageNo = 1;
        this.getOperationData();
      },
      //操作记录查询
      getOperationData() {
        this.operationLogDialog = true;
        this.operationLoading = true;
        this.$http({
          method: 'post',
          url: '/rest/salesman/operationLog',
          data: this.operationLogFormData
        }).then(res => {
          this.operationLogTableData = res.data.data.list;
          this.operationTotal = res.data.data.totalCount;
          this.operationLoading = false;
        }).catch(err => {
          this.operationLoading = false;
          this.$alert("获取操作日志失败！");
        });
      },
      exportOperationData() {
        this.operationLogDialog = true;
        this.operationLoading = true;
        this.$http({
          method: 'post',
          url: '/rest/salesman/operationLog/export',
          data: this.operationLogFormData
        }).then(res => {
          location.href = utils.returnUrlHead() + res.data.data;
          this.operationLoading = false;
        }).catch(err => {
          this.operationLoading = false;
          this.$alert("获取操作日志失败！");
        });
      },
      operationHandleSizeChange(val) {
        this.operationLogFormData.pageSize = val;
        this.getOperationData();
      },
      // 银行卡人工认证
      bankCardArtificial(salesmanId) {
        this.bankCardArtificialData.salesmanId = salesmanId;
        this.$http({
          method: 'get',
          url: '/rest/baseCenter/pre-bankcard-artificial',
          params: {"salesmanId": salesmanId}
        }).then(res => {
          if (res.data.status == 200) {
            let bankcardInfo = res.data.data;
            this.bankCardArtificialData.bank = bankcardInfo.bank;
            this.bankCardArtificialData.bankNum = bankcardInfo.bankNum;
            this.bankCardArtificialData.branch = bankcardInfo.branch;
            this.bankCardArtificialData.salesmanName = bankcardInfo.salesmanName;
            this.bankCardArtificialData.bankCover = bankcardInfo.bankCover;
            this.bankCardArtificialData.bankAddress.province = null;
            this.bankCardArtificialData.bankAddress.city = null;
            this.bankCardArtificialData.bankAddress.area = null;
            this.bankCardArtificialData.bankAddressCode.province = null;
            this.bankCardArtificialData.bankAddressCode.city = null;
            this.bankCardArtificialData.bankAddressCode.area = null;
            this.bankCardArtificialData.branchList = null;
            this.bankCardArtificialData.unionPayNo = null;
            this.bankCardDialogFlag = true;
            this.bankCardArtificialData.applicant = null;
            this.bankCardArtificialData.applyReason = null;
            this.bankCardArtificialData.projectCode = null;
          } else {
            this.bankCardDialogFlag = false;
            this.$alert(res.data.message);
          }
        }).catch(err => {
          this.$alert("无法进行银行卡人工认证！");
        });
      },
      operationHandleCurrentChange(val) {
        this.operationLogFormData.pageNo = val;
        this.getOperationData();
      },
      // 校验银行卡图片
      verifyBankImage(file) {
        let isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        let isLt2M = (file.size / 1024 / 1024) < 1;
        let errMsg = ''
        if (!isLt2M) {
          errMsg = '上传的图片大小不能超过 1MB!';
        } else if (!isJPG) {
          errMsg = '请上传jpg、jpeg或png格式的图片';
        }
        if (errMsg != '') {
          utils.myNotify(this, 'warning', errMsg)
          return false;
        }
        let x = file.name.split(".")
        this.bankCardArtificialData.bankCoverName.name = (new Date()).getTime() + '.' + x[x.length - 1];
      },
      // 银行卡照片上传失败回调
      bankImageOnFailure(err) {
        utils.myNotify(this, 'error', '上传失败，请稍后重试');
      },
      // 银行卡照片上传成功回调
      bankImageOnSuccess(res, file) {
        let filePath = res.message;
        this.bankCardArtificialData.bankCover = filePath.substring(filePath.indexOf("https://resource.plscn.com/fileupload/") + "https://resource.plscn.com/fileupload/".length, filePath.length);
      },
      // 校验银行卡号
      validateIdCard() {
        return (/^\d{15,19}$/.test(this.bankCardArtificialData.bankNum)) ? {valid: true} : {
          valid: false,
          msg: '请输入正确的银行卡！'
        }
      },
      // 获取开户行信息
      getBank() {
        let validateResult = this.validateIdCard();
        if (!validateResult.valid) {
          this.bankCardArtificialData.bank = null;
          this.$alert(validateResult.msg);
          return;
        }
        if (this.bankCardArtificialData.bankNum.length >= 15) {
          this.$http({
            method: "GET",
            url: "/rest/BankSubordinate/searchBankName",
            params: {
              bankNumber: this.bankCardArtificialData.bankNum,
            }
          }).then(res => {
            if (res.data.message != '银行卡无效，请填写正确的银行卡！') {
              this.bankCardArtificialData.bank = res.data.message;
            }
          })
        }
      },
      chooseProvince(data) {
        this.bankCardArtificialData.bankAddress.province = data.value;
        this.bankCardArtificialData.bankAddress.city = null;
        this.bankCardArtificialData.bankAddress.area = null;
        this.bankCardArtificialData.bankAddressCode.province = data.code;
        this.bankCardArtificialData.bankAddressCode.city = null;
        this.bankCardArtificialData.bankAddressCode.area = null;
        this.bankCardArtificialData.branchList = null;
      },
      chooseCity(data) {
        this.bankCardArtificialData.bankAddress.city = data.value;
        this.bankCardArtificialData.bankAddress.area = null;
        this.bankCardArtificialData.bankAddressCode.city = data.code;
        this.bankCardArtificialData.bankAddressCode.area = null;
        if (data.value == '东莞市' || data.value == '中山市') {
          this.searchBankBranchList();
        }
      },
      chooseArea(data) {
        if (data.value != '区') {
          this.bankCardArtificialData.bankAddressCode.area = data.code;
          this.bankCardArtificialData.bankAddress.area = data.value;
        } else {
          this.bankCardArtificialData.bankAddressCode.area = "--";
          this.bankCardArtificialData.bankAddress.area = "";
        }
        this.searchBankBranchList();
      },
      // 获取开户支行列表
      searchBankBranchList() {
        if (this.bankCardArtificialData.bank == null) {
          this.$alert("请先填写正确的银行卡号！");
          return;
        }
        let queryParam = {
          bankcard: this.bankCardArtificialData.bankNum,
          bankname: this.bankCardArtificialData.bank,//银行
          city: (this.bankCardArtificialData.bankAddress.city.indexOf('城区') != -1 || this.bankCardArtificialData.bankAddress.city.indexOf('市辖区') != -1) ? this.bankCardArtificialData.bankAddress.province : this.bankCardArtificialData.bankAddress.city,
          district: this.bankCardArtificialData.bankAddress.area,
          province: this.bankCardArtificialData.bankAddress.province,
          page: 1
        };
        this.queryBranchInfo(queryParam, []);
      },
      // 递归查询所有支行信息
      queryBranchInfo(param, list) {
        this.$http({
          method: "GET",
          url: "/rest/BankSubordinate/getLhhList",
          params: param
        }).then(res => {
          let data = res.data.data.result;
          if (data.list) {
            for (let i = 0; i < data.list.length; i++) {
              list.push(data.list[i]);
            }
          }

          let pager = data.paging;
          if (pager.page_total > param.page && param.page <= 10) {
            param.page = param.page + 1;
            // 递归查询
            this.queryBranchInfo(param, list);
          } else {
            if (data.list) {
              this.bankCardArtificialData.branchList = list;
            } else {
              this.bankCardArtificialData.branchList = [];
            }
          }
        });
      },
      // 获取银联号
      getUnionPayNo() {
        this.bankCardArtificialData.unionPayNo = this.bankCardArtificialData.branch.number;
      },
      // 取消银行卡认证
      bankCardArtificialCancel() {
        this.bankCardDialogFlag = false;
        // this.clearBankCardArtificialData();
      },
      // 银行卡人工认证
      bankCardArtificialConfirm() {
        // 检验字段非空
        if (!this.verifyBankCardInfo()) {
          return
        }
        let bankCardInfo = {
          salesmanId: this.bankCardArtificialData.salesmanId,
          bankNum: this.bankCardArtificialData.bankNum,
          bank: this.bankCardArtificialData.bank,
          // bankAddress: this.bankCardArtificialData.bankAddress.province + "," + this.bankCardArtificialData.bankAddress.city + "," + this.bankCardArtificialData.bankAddress.area,
          bankAddressCode: this.bankCardArtificialData.bankAddressCode.province + "," + this.bankCardArtificialData.bankAddressCode.city + "," + this.bankCardArtificialData.bankAddressCode.area,
          // bankBranch: this.bankCardArtificialData.branch.branchname,
          // unionPayNum: this.bankCardArtificialData.unionPayNo,
          bankCover: this.bankCardArtificialData.bankCover,
          applicant: this.bankCardArtificialData.applicant,
          applyReason: this.bankCardArtificialData.applyReason,
          projectCode: this.bankCardArtificialData.projectCode?this.bankCardArtificialData.projectCode.split('&')[0]:'',
          orgName: this.getOptcode("bank")
        }
        // console.log("!!!!!!!", bankCardInfo);
        // return
        // 银行卡人工认证
        this.$http({
          method: 'post',
          url: '/rest/baseCenter/bankcard-artificial',
          data: bankCardInfo
        }).then(res => {
          if (res.data.code == '0') {
            utils.myNotify(this, 'success', '认证成功！');
            this.bankCardDialogFlag = false;
            this.getData();
          } else {
            utils.myNotify(this, 'error', res.data.message);
          }
        }).catch(err => {
          utils.myNotify(this, 'error', '银行卡人工认证失败！')
          console.log(err)
        });
      },
      // 校验银行卡人工认证字段
      verifyBankCardInfo() {
        if (this.bankCardArtificialData.bankNum == null || this.bankCardArtificialData.bankNum == '') {
          // this.$alert("银行卡号码不能为空！");
          utils.myNotify(this, 'warning', '银行卡号码不能为空！')
          return false;
        }
        if (this.bankCardArtificialData.bank == null || this.bankCardArtificialData.bank == '') {
          // this.$alert("开户行不能为空！");
          utils.myNotify(this, 'warning', '开户行不能为空！')
          return false;
        }
        if (this.bankCardArtificialData.applicant == null || this.bankCardArtificialData.applicant == '' || this.bankCardArtificialData.applicant == '--') {
          // this.$alert("申请人不能为空！");
          utils.myNotify(this, 'warning', '必须填写申请人！')
          return false;
        }
        if (this.bankCardArtificialData.applyReason == null || this.bankCardArtificialData.applyReason == null || this.bankCardArtificialData.applyReason == '') {
          // this.$alert("申请原因不能为空！");
          utils.myNotify(this, 'warning', '必须填写申请原因！')
          return false;
        }
        if (this.bankCardArtificialData.bankCover == null || this.bankCardArtificialData.bankCover == '') {
          // this.$alert("银行卡照片不能为空！");
          utils.myNotify(this, 'warning', '银行卡照片不能为空！')
          return false;
        }
        return true;
      },
      // 查询所有项目客户
      searchAllCustomer() {
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/all-customers'
        }).then(res => {
          this.customerList = res.data.data
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      openContractDialog(idcard, salesmanName) {
        this.contractDialogTitle = salesmanName;
        this.contractFormData.idcard = idcard;
        this.showContractDialog = true;
        this.searchContractData();
      },
      searchContractData() {
        this.contractFormData.pageNo = 1;
        this.contractFormData.pageSize = 10;
        this.contractLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/contract-history',
          params: this.contractFormData
        }).then(res => {
          this.contractData = res.data.data.items;
          this.contractTotal = res.data.data.totalItemsCount;
          this.contractLoading = false;
        }).catch(err => {
          this.contractLoading = false;
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      handleContractSizeChange(val) {
        this.contractFormData.pageSize = val;
        this.searchContractData();
      },
      handleContractCurrentChange(val) {
        this.contractFormData.pageNo = val;
        this.searchContractData();
      },
      showAuthorize(salesmanId, name) {
        this.authorizeDialogFlag = true;
        this.authorizeDialogSalesmanName = name;
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/authorize-history',
          params: {
            salesmanId: salesmanId
          }
        }).then(res => {
          this.authorizeDialogList = res.data;
        }).catch(err => {
          this.authorizeDialogFlag = false;
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },

      //获取所属项目对应的信息
      getProjDropDownList(){
        this.$http({
        method: "GET",
        url: "/rest/project/projectDropDownList",
      })
        .then((res) => {
          this.projectDropDownList = res.data.items.map((item)=>{
            return {
              label:`（${ item.projectCode}）${item.projectName}`,
              valueOrgcode:item.orgName?item.projectCode+'&'+item.orgName:item.projectCode
            }
          });
          this.projectDropDownListKeep = JSON.parse(JSON.stringify(this.projectDropDownList))
          // console.log(res.data.items , "aaaaaaaaa" , this.projectDropDownList);
        })
        .catch((err) => {
          utils.myNotify(this, "error", err.response, "获取失败，请稍后重试");
        });
      },
      getOptcode(a){
        if(a === "idcard"){
          let list = this.approveData.projectCode?this.approveData.projectCode.split('&'):[]
          if (list.length>1) {//存在orgCode
            return list[1]
          }else{
            return null
          }
        }else{
          let list = this.bankCardArtificialData.projectCode?this.bankCardArtificialData.projectCode.split('&'):[]
          if (list.length>1) {//存在orgCode
            return list[1]
          }else{

            return null
          }
        }
        
      }
      // ,
      // //注销用户
      // logout(){
      //   let list =  this.resultList;
      //   let flag = 0;
      //   console.log('list',list);
      //   list.forEach(element=>{
      //     console.log('element',element);
      //     if (element.isLogout==0) {
      //       flag = 1;
      //       utils.myNotify(this, "error", element, '该人员未申请注销！')
      //     }
      //   })
      //   // 都申请注销了
      //   if(flag==0){
      //     this.$confirm('确认注销吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(()=>{
      //     let idArr = []
      //     this.idList.forEach(item => {
      //       idArr.push(item.id)
      //     })
      //     this.listLoading = true;
      //     this.$http({
      //       method:"POST",
      //       url:"/rest/baseCenter/logoutByIds",
      //       data: idArr
      //     }).then((res)=>{
      //       if (res.data.code == '0' && res.data.status == 200) {
      //         this.getData()
      //         utils.myNotify(this, "success", '注销成功', '操作成功')
      //       }else {
      //         utils.myNotify(this, "error", res, '操作失败，请稍后重试')
      //       }
      //     }).catch(err => {
      //     utils.myNotify(this, "error", err.response, '查询失败，请稍后重试')
      //     this.listLoading = false;
      //   })
      //   })
      //   }
      // }
      // ,
      // //筛选select
      // filterMethod(val){
      //   if (val) {
      //   //val存在筛选数组
      //   this.projectDropDownList = this.projectDropDownListKeep.filter((el) => {
      //     let re = new RegExp(val, 'i')
      //     return re.test(el.label)
      //   })
      // } else {
      //   //val不存在还原数组
      //   this.projectDropDownList = this.projectDropDownListKeep
      // }
      // }
    }
  }
</script>

<style lang="scss" scoped>
  // 查看大图
  .dialog {
    .dialogImage {
      // padding: 20px;
      min-height: 300px;
      background-repeat: no-repeat;
      background-size: 100% !important;
      background-position: center !important;
      img {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }

  .tableImg {
    width: 50px;
    height: 30px;
    margin: 0 auto;
    img {
      opacity: 0
    }
  }

  .dialogImg {
    width: 360px;
    height: 230px;
    img {
      opacity: 0
    }
  }

  .bankImg {
    width: 360px;
    height: 230px;
    img {
      opacity: 0
    }
  }

  .blacklistDialog {
    .dialog-body {
      .reason {
        background: #f4f4f4;
        box-sizing: border-box;
        width: 100%;
        border-radius: 5px;
        textarea {
          background: #f4f4f4;
        }
      }
    }
  }

  .cardDialog {
    .card-img {
      p {
        line-height: 32px;
        color: #666;
      }
      img {
        width: 360px;
        height: 230px;
      }
    }
  }

  .required {
    color: #f6914b;
  }

  .mylabel {
    width: 120px;
    line-height: 28px;
    float: none;
    display: inline-block;
    cursor: pointer;
    text-align: right;
    vertical-align: top;
    font-size: 14px;
    color: #5a5e66;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .headImg, .idcardImg {
    margin-bottom: 10px;
  }

  .wrap {
    background-color: #f2f2f2;
    border-radius: 5px;
    margin-bottom: 10px;
    font-size: 14px !important;
    .title {
      padding: 5px 10px;
      border-bottom: 1px solid white;
    }
    .content {
      padding: 20px;
    }
  }
</style>
<style lang="scss">
  .blacklistDialog .el-textarea__inner {
    border: none !important;
  }

  //头行如果是两行字，则降低lineheight为15px
  .basecenter .doubleRow {
    line-height: 15px
  }
</style>



// WEBPACK FOOTER //
// src/views/personnelCenter/baseCenter.vue